import {
  VOID3gxj6tk5isa35 as VOID,
  StringBuilder_init_$Create$2qsge4ydj6bin as StringBuilder_init_$Create$,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char__plus_impl_qi7pgj3akekecdud2w6 as Char__plus_impl_qi7pgj,
  Char__minus_impl_a2frrh3t0v4pviuv4om as Char__minus_impl_a2frrh,
  charArray2ujmm1qusno00 as charArray,
  concatToString2syawgu50khxi as concatToString,
  charCodeAt1yspne1d8erbm as charCodeAt,
  substringiqarkczpya5m as substring,
  toString1pkumu07cwy4m as toString,
  Char19o2r8palgjof as Char,
  isSurrogatewe8xicw8z84n as isSurrogate,
  StringBuilder_init_$Create$2ujvu6cqvzuyn as StringBuilder_init_$Create$_0,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  toString3o7ifthqydp6e as toString_0,
  toByte4i43936u611k as toByte,
  decodeToString1dbzcjd620q25 as decodeToString,
  Exceptiondt2hlxn7j7vw as Exception,
  Exception_init_$Init$33ewqhqmjrfx6 as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Char__minus_impl_a2frrh3548ixwefqxih as Char__minus_impl_a2frrh_0,
  Char__toInt_impl_vasixd1agw9q2fuvclj as Char__toInt_impl_vasixd,
  numberToChar93r9buh19yek as numberToChar,
  Char__rangeTo_impl_tkncvp2wb70up86k2i2 as Char__rangeTo_impl_tkncvp,
  plus39kp8wyage607 as plus,
  plus310ted5e4i90h as plus_0,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$3bxttkj3v1mea as ArrayList_init_$Create$,
  toSet2orjxp16sotqu as toSet,
  setOf45ia9pnfhe90 as setOf,
  plus1ogy4liedzq5j as plus_1,
  listOf1jh22dvmctj1r as listOf,
  emptyList1g2z5xcrvp2zy as emptyList,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  equals2v6cggk171b6e as equals,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  isBlank1dvkhjjvox3p0 as isBlank,
  last1vo29oleiqj36 as last,
  indexOf1xbs558u7wr52 as indexOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  substring3saq8ornu0luv as substring_0,
  contains2el4s70rdq4ld as contains,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  startsWith38d3sbg25w0lx as startsWith,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  plus20p0vtfmu0596 as plus_2,
  equals2au1ep9vhcato as equals_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  emptyMapr06gerzljqtm as emptyMap,
  toString30pk9tzaqopn as toString_1,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  mapsbvh18eqox7a as map,
  filter184huxd00uyfg as filter,
  toMap2blj7l1rjb1hx as toMap,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  Enum3alwj03lh1n41 as Enum,
  startsWith26w8qjqapeeq6 as startsWith_0,
  NoSuchElementException_init_$Create$4w03vct39ryy as NoSuchElementException_init_$Create$,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  LinkedHashMap_init_$Create$23uxki4opd0pn as LinkedHashMap_init_$Create$,
  KtMap140uvy3s5zad8 as KtMap,
  LinkedHashMap_init_$Create$1f9mb1z5f3dxn as LinkedHashMap_init_$Create$_0,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  trimStart5ewg8zf6cs5u as trimStart,
  trimEnd17pt8cbotbalj as trimEnd,
  endsWith3cq61xxngobwh as endsWith,
  removeSurroundingtenczfhnh0cp as removeSurrounding,
  toLongkk4waq8msp1k as toLong,
  coerceIn302bduskdb54x as coerceIn,
  convertToInty04h231mmjoh as convertToInt,
  isWhitespace25occ8z1ed1s9 as isWhitespace,
  Char__compareTo_impl_ypi4mbdrkik40uwhqc as Char__compareTo_impl_ypi4mb,
  to2cs3ny02qtbcb as to,
  Regex_init_$Create$20u56movc9c5j as Regex_init_$Create$,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalStateException_init_$Init$28k6zlhbptery as IllegalStateException_init_$Init$,
  toInt2q8uldh7sc951 as toInt,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  first3kg261hmihapu as first,
  last2n4gf5az1lkn4 as last_0,
  get_lastIndexld83bqhfgcdd as get_lastIndex_0,
  listOfvhqybd2zx248 as listOf_0,
  emptySetcxexqki71qfa as emptySet,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  sortedWith2csnbbb21k0lg as sortedWith,
  LazyThreadSafetyMode_NONE_getInstance2ezxh11hvaa3w as LazyThreadSafetyMode_NONE_getInstance,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$_0,
  asList2ho2pewtsfvv as asList,
  IllegalArgumentException_init_$Init$1ke5df1bctk2y as IllegalArgumentException_init_$Init$,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  addAll1k27qatfgp3k5 as addAll,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Comparable198qfk8pnblz0 as Comparable,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  startsWith1bgirhbedtv2y as startsWith_1,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split,
  toMutableList20rdgwi7d3cwi as toMutableList,
  first58ocm7j58k3q as first_0,
  joinToString1cxrrlmo0chqs as joinToString,
  indexOfAny2ijjuuzpljsyd as indexOfAny,
  dropLast1vpiyky649o34 as dropLast,
  IllegalStateException_init_$Init$3ccqbeatlpw5c as IllegalStateException_init_$Init$_0,
  indexOfwa4w6635jewi as indexOf_0,
  joinTo3lkanfaxbzac2 as joinTo,
  lazy2hsh8ze7j6ikd as lazy_0,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  fromInt2ii0rejb1w62w as fromInt,
  take9j4462mea726 as take,
  Companion_getInstanceduyatss8wab7 as Companion_getInstance,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Charsets_getInstanceqs70pvl4noow as Charsets_getInstance,
  encode35e4rpnc94tb5 as encode,
  takeWhile34751tcfg6owx as takeWhile,
  canRead1guo8vbveth0f as canRead,
  forName2faodmskqnoz5 as forName,
  get_name2f11g4r0d5pxp as get_name,
  toByteArray1i3ns5jnoqlv6 as toByteArray,
} from './ktor-ktor-io.mjs';
import {
  createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer,
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  get_nullable197rfua9r7fsz as get_nullable,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  UnknownFieldException_init_$Create$hprktcyan42n as UnknownFieldException_init_$Create$,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  STRING_getInstance2ou4lro9xn2qn as STRING_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  KSerializerzf77vz1967fq as KSerializer,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  $serializer_getInstance3eoaslyziseik as $serializer_getInstance,
  toLowerCasePreservingASCIIRulesa2d90zyoc6kw as toLowerCasePreservingASCIIRules,
  encodeBase648nmrpg7xt514 as encodeBase64,
  decodeBase64String12gg4kf1zr4tn as decodeBase64String,
  GMTDate3m9k1iwfh2c2u as GMTDate,
  get_entries29zivfnwin9bs as get_entries,
  GMTDateParser2n3dcykk4v76n as GMTDateParser,
  InvalidDateStringException32oxg8bbalei2 as InvalidDateStringException,
  StringValuesBuilderImpl3ey9etj3bwnqf as StringValuesBuilderImpl,
  StringValuesImpl2l95y9du7b61t as StringValuesImpl,
  StringValuesjqid5a6cuday as StringValues,
  get3oezx9z3zutmm as get,
  forEachghjt92rkrpzo as forEach,
  StringValuesSingleImpl1uh7q2c2zm7va as StringValuesSingleImpl,
  toCharArray1qby3f4cdahde as toCharArray,
  isLowerCase2jodys5jo7d58 as isLowerCase,
  appendAlltwnjnu28pmtx as appendAll,
  PlatformUtils_getInstance350nj2wi6ds9r as PlatformUtils_getInstance,
} from './ktor-ktor-utils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(URLDecodeException, 'URLDecodeException', VOID, Exception);
initMetadataForCompanion(Companion);
initMetadataForObject(Application, 'Application');
initMetadataForObject(MultiPart, 'MultiPart');
initMetadataForObject(Text, 'Text');
initMetadataForClass(HeaderValueWithParameters, 'HeaderValueWithParameters');
initMetadataForClass(ContentType, 'ContentType', VOID, HeaderValueWithParameters);
initMetadataForClass(BadContentTypeFormatException, 'BadContentTypeFormatException', VOID, Exception);
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Cookie, 'Cookie', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForClass(CookieEncoding, 'CookieEncoding', VOID, Enum);
initMetadataForClass(CookieDateParser, 'CookieDateParser', CookieDateParser);
initMetadataForClass(InvalidCookieDateException, 'InvalidCookieDateException', VOID, IllegalStateException);
initMetadataForClass(StringLexer, 'StringLexer');
initMetadataForClass(CookieDateBuilder, 'CookieDateBuilder', CookieDateBuilder);
initMetadataForCompanion(Companion_1);
initMetadataForClass(HeadersBuilder, 'HeadersBuilder', HeadersBuilder, StringValuesBuilderImpl);
initMetadataForCompanion(Companion_2);
initMetadataForClass(HeadersImpl, 'HeadersImpl', HeadersImpl, StringValuesImpl, [StringValues, StringValuesImpl]);
initMetadataForObject(EmptyHeaders, 'EmptyHeaders', VOID, VOID, [StringValues]);
initMetadataForClass(HeadersSingleImpl, 'HeadersSingleImpl', VOID, StringValuesSingleImpl, [StringValues, StringValuesSingleImpl]);
initMetadataForClass(HeaderValue, 'HeaderValue');
initMetadataForClass(HeaderValueParam, 'HeaderValueParam');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(HttpHeaders, 'HttpHeaders');
initMetadataForClass(UnsafeHeaderException, 'UnsafeHeaderException', VOID, IllegalArgumentException);
initMetadataForClass(IllegalHeaderNameException, 'IllegalHeaderNameException', VOID, IllegalArgumentException);
initMetadataForClass(IllegalHeaderValueException, 'IllegalHeaderValueException', VOID, IllegalArgumentException);
initMetadataForCompanion(Companion_3);
initMetadataForClass(HttpMethod, 'HttpMethod');
initMetadataForCompanion(Companion_4);
initMetadataForClass(HttpProtocolVersion, 'HttpProtocolVersion');
initMetadataForCompanion(Companion_5);
initMetadataForClass(HttpStatusCode, 'HttpStatusCode', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_6);
initMetadataForInterface(Parameters, 'Parameters', VOID, VOID, [StringValues]);
initMetadataForObject(EmptyParameters, 'EmptyParameters', VOID, VOID, [Parameters]);
initMetadataForClass(ParametersBuilderImpl, 'ParametersBuilderImpl', ParametersBuilderImpl, StringValuesBuilderImpl);
initMetadataForClass(ParametersImpl, 'ParametersImpl', ParametersImpl, StringValuesImpl, [Parameters, StringValuesImpl]);
initMetadataForCompanion(Companion_7);
initMetadataForClass(URLBuilder, 'URLBuilder', URLBuilder);
initMetadataForClass(URLParserException, 'URLParserException', VOID, IllegalStateException);
initMetadataForCompanion(Companion_8);
initMetadataForClass(URLProtocol, 'URLProtocol');
initMetadataForCompanion(Companion_9);
initMetadataForClass(Url_0, 'Url', VOID, VOID, VOID, VOID, VOID, {0: UrlSerializer_getInstance});
initMetadataForObject(UrlSerializer, 'UrlSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(UrlDecodedParametersBuilder, 'UrlDecodedParametersBuilder');
initMetadataForClass(OutgoingContent, 'OutgoingContent');
initMetadataForClass(ByteArrayContent_0, 'ByteArrayContent', VOID, OutgoingContent);
initMetadataForClass(ByteArrayContent, 'ByteArrayContent', VOID, ByteArrayContent_0);
initMetadataForInterface(MultiPartData, 'MultiPartData', VOID, VOID, VOID, [0]);
initMetadataForClass(NoContent, 'NoContent', VOID, OutgoingContent);
initMetadataForClass(ReadChannelContent, 'ReadChannelContent', VOID, OutgoingContent);
initMetadataForClass(WriteChannelContent, 'WriteChannelContent', VOID, OutgoingContent, VOID, [1]);
initMetadataForClass(ProtocolUpgrade, 'ProtocolUpgrade', VOID, OutgoingContent, VOID, [4]);
initMetadataForClass(ContentWrapper, 'ContentWrapper', VOID, OutgoingContent);
initMetadataForObject(NullBody, 'NullBody');
initMetadataForClass(TextContent, 'TextContent', VOID, ByteArrayContent_0);
initMetadataForClass(Grammar, 'Grammar');
initMetadataForInterface(ComplexGrammar, 'ComplexGrammar');
initMetadataForClass(SequenceGrammar, 'SequenceGrammar', VOID, Grammar, [Grammar, ComplexGrammar]);
initMetadataForClass(StringGrammar, 'StringGrammar', VOID, Grammar);
initMetadataForInterface(SimpleGrammar, 'SimpleGrammar');
initMetadataForClass(AtLeastOne, 'AtLeastOne', VOID, Grammar, [Grammar, SimpleGrammar]);
initMetadataForClass(OrGrammar, 'OrGrammar', VOID, Grammar, [Grammar, ComplexGrammar]);
initMetadataForClass(RawGrammar, 'RawGrammar', VOID, Grammar);
initMetadataForClass(NamedGrammar, 'NamedGrammar', VOID, Grammar);
initMetadataForClass(MaybeGrammar, 'MaybeGrammar', VOID, Grammar, [Grammar, SimpleGrammar]);
initMetadataForClass(ManyGrammar, 'ManyGrammar', VOID, Grammar, [Grammar, SimpleGrammar]);
initMetadataForClass(AnyOfGrammar, 'AnyOfGrammar', VOID, Grammar);
initMetadataForClass(RangeGrammar, 'RangeGrammar', VOID, Grammar);
initMetadataForClass(RegexParser, 'RegexParser');
initMetadataForClass(GrammarRegex, 'GrammarRegex');
//endregion
function get_URL_ALPHABET() {
  _init_properties_Codecs_kt__fudxxf();
  return URL_ALPHABET;
}
var URL_ALPHABET;
function get_URL_ALPHABET_CHARS() {
  _init_properties_Codecs_kt__fudxxf();
  return URL_ALPHABET_CHARS;
}
var URL_ALPHABET_CHARS;
function get_HEX_ALPHABET() {
  _init_properties_Codecs_kt__fudxxf();
  return HEX_ALPHABET;
}
var HEX_ALPHABET;
function get_URL_PROTOCOL_PART() {
  _init_properties_Codecs_kt__fudxxf();
  return URL_PROTOCOL_PART;
}
var URL_PROTOCOL_PART;
function get_VALID_PATH_PART() {
  _init_properties_Codecs_kt__fudxxf();
  return VALID_PATH_PART;
}
var VALID_PATH_PART;
var ATTRIBUTE_CHARACTERS;
function get_SPECIAL_SYMBOLS() {
  _init_properties_Codecs_kt__fudxxf();
  return SPECIAL_SYMBOLS;
}
var SPECIAL_SYMBOLS;
function encodeURLParameter(_this__u8e3s4, spaceToPlus) {
  spaceToPlus = spaceToPlus === VOID ? false : spaceToPlus;
  _init_properties_Codecs_kt__fudxxf();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  var content = encode(Charsets_getInstance().g2u_1.k2u(), _this__u8e3s4);
  forEach_0(content, encodeURLParameter$lambda(this_0, spaceToPlus));
  return this_0.toString();
}
function decodeURLPart(_this__u8e3s4, start, end, charset) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.length : end;
  charset = charset === VOID ? Charsets_getInstance().g2u_1 : charset;
  _init_properties_Codecs_kt__fudxxf();
  return decodeScan(_this__u8e3s4, start, end, false, charset);
}
function encodeURLQueryComponent(_this__u8e3s4, encodeFull, spaceToPlus, charset) {
  encodeFull = encodeFull === VOID ? false : encodeFull;
  spaceToPlus = spaceToPlus === VOID ? false : spaceToPlus;
  charset = charset === VOID ? Charsets_getInstance().g2u_1 : charset;
  _init_properties_Codecs_kt__fudxxf();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  var content = encode(charset.k2u(), _this__u8e3s4);
  forEach_0(content, encodeURLQueryComponent$lambda(spaceToPlus, this_0, encodeFull));
  return this_0.toString();
}
function decodeURLQueryComponent(_this__u8e3s4, start, end, plusIsSpace, charset) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.length : end;
  plusIsSpace = plusIsSpace === VOID ? false : plusIsSpace;
  charset = charset === VOID ? Charsets_getInstance().g2u_1 : charset;
  _init_properties_Codecs_kt__fudxxf();
  return decodeScan(_this__u8e3s4, start, end, plusIsSpace, charset);
}
function encodeURLPathPart(_this__u8e3s4) {
  _init_properties_Codecs_kt__fudxxf();
  return encodeURLPath(_this__u8e3s4, true);
}
function encodeURLParameterValue(_this__u8e3s4) {
  _init_properties_Codecs_kt__fudxxf();
  return encodeURLParameter(_this__u8e3s4, true);
}
function hexDigitToChar(digit) {
  _init_properties_Codecs_kt__fudxxf();
  return (0 <= digit ? digit <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), digit) : Char__minus_impl_a2frrh(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(65), digit), 10);
}
function forEach_0(_this__u8e3s4, block) {
  _init_properties_Codecs_kt__fudxxf();
  takeWhile(_this__u8e3s4, forEach$lambda(block));
}
function percentEncode(_this__u8e3s4) {
  _init_properties_Codecs_kt__fudxxf();
  var code = _this__u8e3s4 & 255;
  var array = charArray(3);
  array[0] = _Char___init__impl__6a9atx(37);
  array[1] = hexDigitToChar(code >> 4);
  array[2] = hexDigitToChar(code & 15);
  return concatToString(array);
}
function decodeScan(_this__u8e3s4, start, end, plusIsSpace, charset) {
  _init_properties_Codecs_kt__fudxxf();
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ch = charCodeAt(_this__u8e3s4, index);
      if (ch === _Char___init__impl__6a9atx(37) || (plusIsSpace && ch === _Char___init__impl__6a9atx(43))) {
        return decodeImpl(_this__u8e3s4, start, end, index, plusIsSpace, charset);
      }
    }
     while (inductionVariable < end);
  return start === 0 && end === _this__u8e3s4.length ? toString(_this__u8e3s4) : substring(_this__u8e3s4, start, end);
}
function encodeURLPath(_this__u8e3s4, encodeSlash, encodeEncoded) {
  encodeSlash = encodeSlash === VOID ? false : encodeSlash;
  encodeEncoded = encodeEncoded === VOID ? true : encodeEncoded;
  _init_properties_Codecs_kt__fudxxf();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  var charset = Charsets_getInstance().g2u_1;
  var index = 0;
  $l$loop_0: while (index < _this__u8e3s4.length) {
    var current = charCodeAt(_this__u8e3s4, index);
    if (!encodeSlash && current === _Char___init__impl__6a9atx(47) || get_URL_ALPHABET_CHARS().q1(new Char(current)) || get_VALID_PATH_PART().q1(new Char(current))) {
      this_0.l7(current);
      index = index + 1 | 0;
      continue $l$loop_0;
    }
    if (!encodeEncoded && current === _Char___init__impl__6a9atx(37) && (index + 2 | 0) < _this__u8e3s4.length && get_HEX_ALPHABET().q1(new Char(charCodeAt(_this__u8e3s4, index + 1 | 0))) && get_HEX_ALPHABET().q1(new Char(charCodeAt(_this__u8e3s4, index + 2 | 0)))) {
      this_0.l7(current);
      this_0.l7(charCodeAt(_this__u8e3s4, index + 1 | 0));
      this_0.l7(charCodeAt(_this__u8e3s4, index + 2 | 0));
      index = index + 3 | 0;
      continue $l$loop_0;
    }
    var symbolSize = isSurrogate(current) ? 2 : 1;
    var tmp = encode(charset.k2u(), _this__u8e3s4, index, index + symbolSize | 0);
    forEach_0(tmp, encodeURLPath$lambda(this_0));
    index = index + symbolSize | 0;
  }
  return this_0.toString();
}
function decodeImpl(_this__u8e3s4, start, end, prefixEnd, plusIsSpace, charset) {
  _init_properties_Codecs_kt__fudxxf();
  var length = end - start | 0;
  var sbSize = length > 255 ? length / 3 | 0 : length;
  var sb = StringBuilder_init_$Create$_0(sbSize);
  if (prefixEnd > start) {
    sb.vb(_this__u8e3s4, start, prefixEnd);
  }
  var index = prefixEnd;
  var bytes = null;
  while (index < end) {
    var c = charSequenceGet(_this__u8e3s4, index);
    if (plusIsSpace && c === _Char___init__impl__6a9atx(43)) {
      sb.l7(_Char___init__impl__6a9atx(32));
      index = index + 1 | 0;
    } else if (c === _Char___init__impl__6a9atx(37)) {
      if (bytes == null) {
        bytes = new Int8Array((end - index | 0) / 3 | 0);
      }
      var count = 0;
      while (index < end && charSequenceGet(_this__u8e3s4, index) === _Char___init__impl__6a9atx(37)) {
        if ((index + 2 | 0) >= end) {
          // Inline function 'kotlin.text.substring' call
          var startIndex = index;
          var endIndex = charSequenceLength(_this__u8e3s4);
          var tmp$ret$0 = toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex));
          throw new URLDecodeException('Incomplete trailing HEX escape: ' + tmp$ret$0 + ', in ' + toString(_this__u8e3s4) + ' at ' + index);
        }
        var digit1 = charToHexDigit(charSequenceGet(_this__u8e3s4, index + 1 | 0));
        var digit2 = charToHexDigit(charSequenceGet(_this__u8e3s4, index + 2 | 0));
        if (digit1 === -1 || digit2 === -1) {
          throw new URLDecodeException('Wrong HEX escape: %' + toString_0(charSequenceGet(_this__u8e3s4, index + 1 | 0)) + toString_0(charSequenceGet(_this__u8e3s4, index + 2 | 0)) + ', in ' + toString(_this__u8e3s4) + ', at ' + index);
        }
        var tmp = bytes;
        var _unary__edvuaz = count;
        count = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = toByte(imul(digit1, 16) + digit2 | 0);
        index = index + 3 | 0;
      }
      sb.k7(decodeToString(bytes, 0, 0 + count | 0));
    } else {
      sb.l7(c);
      index = index + 1 | 0;
    }
  }
  return sb.toString();
}
function URLDecodeException(message) {
  Exception_init_$Init$(message, this);
  captureStack(this, URLDecodeException);
}
function charToHexDigit(c2) {
  _init_properties_Codecs_kt__fudxxf();
  return (_Char___init__impl__6a9atx(48) <= c2 ? c2 <= _Char___init__impl__6a9atx(57) : false) ? Char__minus_impl_a2frrh_0(c2, _Char___init__impl__6a9atx(48)) : (_Char___init__impl__6a9atx(65) <= c2 ? c2 <= _Char___init__impl__6a9atx(70) : false) ? Char__minus_impl_a2frrh_0(c2, _Char___init__impl__6a9atx(65)) + 10 | 0 : (_Char___init__impl__6a9atx(97) <= c2 ? c2 <= _Char___init__impl__6a9atx(102) : false) ? Char__minus_impl_a2frrh_0(c2, _Char___init__impl__6a9atx(97)) + 10 | 0 : -1;
}
function encodeURLParameter$lambda($$this$buildString, $spaceToPlus) {
  return function (it) {
    if (get_URL_ALPHABET().q1(it) || get_SPECIAL_SYMBOLS().q1(it))
      $$this$buildString.l7(numberToChar(it));
    else {
      var tmp;
      if ($spaceToPlus) {
        var tmp_0 = it;
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(32);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        tmp = tmp_0 === toByte(tmp$ret$0);
      } else {
        tmp = false;
      }
      if (tmp)
        $$this$buildString.l7(_Char___init__impl__6a9atx(43));
      else {
        $$this$buildString.k7(percentEncode(it));
      }
    }
    return Unit_instance;
  };
}
function encodeURLQueryComponent$lambda($spaceToPlus, $$this$buildString, $encodeFull) {
  return function (it) {
    var tmp = it;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    if (tmp === toByte(tmp$ret$0))
      if ($spaceToPlus)
        $$this$buildString.l7(_Char___init__impl__6a9atx(43));
      else
        $$this$buildString.k7('%20');
    else {
      if (get_URL_ALPHABET().q1(it) || (!$encodeFull && get_URL_PROTOCOL_PART().q1(it)))
        $$this$buildString.l7(numberToChar(it));
      else {
        $$this$buildString.k7(percentEncode(it));
      }
    }
    return Unit_instance;
  };
}
function forEach$lambda($block) {
  return function (buffer) {
    while (canRead(buffer)) {
      $block(buffer.y1t());
    }
    return true;
  };
}
function encodeURLPath$lambda($$this$buildString) {
  return function (it) {
    $$this$buildString.k7(percentEncode(it));
    return Unit_instance;
  };
}
var properties_initialized_Codecs_kt_hkj9s1;
function _init_properties_Codecs_kt__fudxxf() {
  if (!properties_initialized_Codecs_kt_hkj9s1) {
    properties_initialized_Codecs_kt_hkj9s1 = true;
    // Inline function 'kotlin.collections.map' call
    var this_0 = plus_0(plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.l();
    while (_iterator__ex2g4s.m()) {
      var item = _iterator__ex2g4s.n();
      // Inline function 'kotlin.code' call
      var this_1 = item.e1_1;
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_1);
      var tmp$ret$1 = toByte(tmp$ret$0);
      destination.j(tmp$ret$1);
    }
    URL_ALPHABET = toSet(destination);
    URL_ALPHABET_CHARS = toSet(plus_0(plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))));
    HEX_ALPHABET = toSet(plus_0(plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(102)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(70))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))));
    // Inline function 'kotlin.collections.map' call
    var this_2 = setOf([new Char(_Char___init__impl__6a9atx(58)), new Char(_Char___init__impl__6a9atx(47)), new Char(_Char___init__impl__6a9atx(63)), new Char(_Char___init__impl__6a9atx(35)), new Char(_Char___init__impl__6a9atx(91)), new Char(_Char___init__impl__6a9atx(93)), new Char(_Char___init__impl__6a9atx(64)), new Char(_Char___init__impl__6a9atx(33)), new Char(_Char___init__impl__6a9atx(36)), new Char(_Char___init__impl__6a9atx(38)), new Char(_Char___init__impl__6a9atx(39)), new Char(_Char___init__impl__6a9atx(40)), new Char(_Char___init__impl__6a9atx(41)), new Char(_Char___init__impl__6a9atx(42)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(59)), new Char(_Char___init__impl__6a9atx(61)), new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(126)), new Char(_Char___init__impl__6a9atx(43))]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s_0 = this_2.l();
    while (_iterator__ex2g4s_0.m()) {
      var item_0 = _iterator__ex2g4s_0.n();
      // Inline function 'kotlin.code' call
      var this_3 = item_0.e1_1;
      var tmp$ret$0_0 = Char__toInt_impl_vasixd(this_3);
      var tmp$ret$1_0 = toByte(tmp$ret$0_0);
      destination_0.j(tmp$ret$1_0);
    }
    URL_PROTOCOL_PART = destination_0;
    VALID_PATH_PART = setOf([new Char(_Char___init__impl__6a9atx(58)), new Char(_Char___init__impl__6a9atx(64)), new Char(_Char___init__impl__6a9atx(33)), new Char(_Char___init__impl__6a9atx(36)), new Char(_Char___init__impl__6a9atx(38)), new Char(_Char___init__impl__6a9atx(39)), new Char(_Char___init__impl__6a9atx(40)), new Char(_Char___init__impl__6a9atx(41)), new Char(_Char___init__impl__6a9atx(42)), new Char(_Char___init__impl__6a9atx(43)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(59)), new Char(_Char___init__impl__6a9atx(61)), new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(126))]);
    ATTRIBUTE_CHARACTERS = plus_1(get_URL_ALPHABET_CHARS(), setOf([new Char(_Char___init__impl__6a9atx(33)), new Char(_Char___init__impl__6a9atx(35)), new Char(_Char___init__impl__6a9atx(36)), new Char(_Char___init__impl__6a9atx(38)), new Char(_Char___init__impl__6a9atx(43)), new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(94)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(96)), new Char(_Char___init__impl__6a9atx(124)), new Char(_Char___init__impl__6a9atx(126))]));
    // Inline function 'kotlin.collections.map' call
    var this_4 = listOf([new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(126))]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
    var _iterator__ex2g4s_1 = this_4.l();
    while (_iterator__ex2g4s_1.m()) {
      var item_1 = _iterator__ex2g4s_1.n();
      // Inline function 'kotlin.code' call
      var this_5 = item_1.e1_1;
      var tmp$ret$0_1 = Char__toInt_impl_vasixd(this_5);
      var tmp$ret$1_1 = toByte(tmp$ret$0_1);
      destination_1.j(tmp$ret$1_1);
    }
    SPECIAL_SYMBOLS = destination_1;
  }
}
function ContentType_init_$Init$(contentType, contentSubtype, parameters, $this) {
  parameters = parameters === VOID ? emptyList() : parameters;
  ContentType.call($this, contentType, contentSubtype, contentType + '/' + contentSubtype, parameters);
  return $this;
}
function ContentType_init_$Create$(contentType, contentSubtype, parameters) {
  return ContentType_init_$Init$(contentType, contentSubtype, parameters, objectCreate(protoOf(ContentType)));
}
function hasParameter($this, name, value) {
  var tmp;
  switch ($this.a32_1.o()) {
    case 0:
      tmp = false;
      break;
    case 1:
      // Inline function 'kotlin.let' call

      var it = $this.a32_1.p(0);
      tmp = (equals(it.b32_1, name, true) && equals(it.c32_1, value, true));
      break;
    default:
      var tmp0 = $this.a32_1;
      var tmp$ret$2;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.q();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$2 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.l();
        while (_iterator__ex2g4s.m()) {
          var element = _iterator__ex2g4s.n();
          if (equals(element.b32_1, name, true) && equals(element.c32_1, value, true)) {
            tmp$ret$2 = true;
            break $l$block_0;
          }
        }
        tmp$ret$2 = false;
      }

      tmp = tmp$ret$2;
      break;
  }
  return tmp;
}
function Companion() {
  Companion_instance = this;
  this.e32_1 = ContentType_init_$Create$('*', '*');
}
protoOf(Companion).in = function (value) {
  if (isBlank(value))
    return this.e32_1;
  // Inline function 'io.ktor.http.Companion.parse' call
  var headerValue = last(parseHeaderValue(value));
  var tmp0 = headerValue.f32_1;
  var parameters = headerValue.g32_1;
  var slash = indexOf(tmp0, _Char___init__impl__6a9atx(47));
  if (slash === -1) {
    // Inline function 'kotlin.text.trim' call
    if (toString(trim(isCharSequence(tmp0) ? tmp0 : THROW_CCE())) === '*')
      return Companion_getInstance_0().e32_1;
    throw new BadContentTypeFormatException(value);
  }
  // Inline function 'kotlin.text.trim' call
  var this_0 = substring(tmp0, 0, slash);
  var type = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(type) === 0) {
    throw new BadContentTypeFormatException(value);
  }
  // Inline function 'kotlin.text.trim' call
  var this_1 = substring_0(tmp0, slash + 1 | 0);
  var subtype = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
  if (contains(type, _Char___init__impl__6a9atx(32)) || contains(subtype, _Char___init__impl__6a9atx(32))) {
    throw new BadContentTypeFormatException(value);
  }
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(subtype) === 0) {
    tmp = true;
  } else {
    tmp = contains(subtype, _Char___init__impl__6a9atx(47));
  }
  if (tmp) {
    throw new BadContentTypeFormatException(value);
  }
  return ContentType_init_$Create$(type, subtype, parameters);
};
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance == null)
    new Companion();
  return Companion_instance;
}
function Application() {
  Application_instance = this;
  this.i32_1 = 'application';
  this.j32_1 = ContentType_init_$Create$('application', '*');
  this.k32_1 = ContentType_init_$Create$('application', 'atom+xml');
  this.l32_1 = ContentType_init_$Create$('application', 'cbor');
  this.m32_1 = ContentType_init_$Create$('application', 'json');
  this.n32_1 = ContentType_init_$Create$('application', 'hal+json');
  this.o32_1 = ContentType_init_$Create$('application', 'javascript');
  this.p32_1 = ContentType_init_$Create$('application', 'octet-stream');
  this.q32_1 = ContentType_init_$Create$('application', 'rss+xml');
  this.r32_1 = ContentType_init_$Create$('application', 'soap+xml');
  this.s32_1 = ContentType_init_$Create$('application', 'xml');
  this.t32_1 = ContentType_init_$Create$('application', 'xml-dtd');
  this.u32_1 = ContentType_init_$Create$('application', 'yaml');
  this.v32_1 = ContentType_init_$Create$('application', 'zip');
  this.w32_1 = ContentType_init_$Create$('application', 'gzip');
  this.x32_1 = ContentType_init_$Create$('application', 'x-www-form-urlencoded');
  this.y32_1 = ContentType_init_$Create$('application', 'pdf');
  this.z32_1 = ContentType_init_$Create$('application', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet');
  this.a33_1 = ContentType_init_$Create$('application', 'vnd.openxmlformats-officedocument.wordprocessingml.document');
  this.b33_1 = ContentType_init_$Create$('application', 'vnd.openxmlformats-officedocument.presentationml.presentation');
  this.c33_1 = ContentType_init_$Create$('application', 'protobuf');
  this.d33_1 = ContentType_init_$Create$('application', 'wasm');
  this.e33_1 = ContentType_init_$Create$('application', 'problem+json');
  this.f33_1 = ContentType_init_$Create$('application', 'problem+xml');
}
protoOf(Application).g33 = function (contentType) {
  return startsWith(contentType, 'application/', true);
};
var Application_instance;
function Application_getInstance() {
  if (Application_instance == null)
    new Application();
  return Application_instance;
}
function MultiPart() {
  MultiPart_instance = this;
  this.h33_1 = 'multipart';
  this.i33_1 = ContentType_init_$Create$('multipart', '*');
  this.j33_1 = ContentType_init_$Create$('multipart', 'mixed');
  this.k33_1 = ContentType_init_$Create$('multipart', 'alternative');
  this.l33_1 = ContentType_init_$Create$('multipart', 'related');
  this.m33_1 = ContentType_init_$Create$('multipart', 'form-data');
  this.n33_1 = ContentType_init_$Create$('multipart', 'signed');
  this.o33_1 = ContentType_init_$Create$('multipart', 'encrypted');
  this.p33_1 = ContentType_init_$Create$('multipart', 'byteranges');
}
protoOf(MultiPart).g33 = function (contentType) {
  return startsWith(contentType, 'multipart/', true);
};
var MultiPart_instance;
function MultiPart_getInstance() {
  if (MultiPart_instance == null)
    new MultiPart();
  return MultiPart_instance;
}
function Text() {
  Text_instance = this;
  this.q33_1 = 'text';
  this.r33_1 = ContentType_init_$Create$('text', '*');
  this.s33_1 = ContentType_init_$Create$('text', 'plain');
  this.t33_1 = ContentType_init_$Create$('text', 'css');
  this.u33_1 = ContentType_init_$Create$('text', 'csv');
  this.v33_1 = ContentType_init_$Create$('text', 'html');
  this.w33_1 = ContentType_init_$Create$('text', 'javascript');
  this.x33_1 = ContentType_init_$Create$('text', 'vcard');
  this.y33_1 = ContentType_init_$Create$('text', 'xml');
  this.z33_1 = ContentType_init_$Create$('text', 'event-stream');
}
var Text_instance;
function Text_getInstance() {
  if (Text_instance == null)
    new Text();
  return Text_instance;
}
function ContentType(contentType, contentSubtype, existingContent, parameters) {
  Companion_getInstance_0();
  parameters = parameters === VOID ? emptyList() : parameters;
  HeaderValueWithParameters.call(this, existingContent, parameters);
  this.c34_1 = contentType;
  this.d34_1 = contentSubtype;
}
protoOf(ContentType).e34 = function (name, value) {
  if (hasParameter(this, name, value))
    return this;
  return new ContentType(this.c34_1, this.d34_1, this.z31_1, plus_2(this.a32_1, HeaderValueParam_init_$Create$(name, value)));
};
protoOf(ContentType).f34 = function () {
  return this.a32_1.q() ? this : ContentType_init_$Create$(this.c34_1, this.d34_1);
};
protoOf(ContentType).g34 = function (pattern) {
  if (!(pattern.c34_1 === '*') && !equals(pattern.c34_1, this.c34_1, true)) {
    return false;
  }
  if (!(pattern.d34_1 === '*') && !equals(pattern.d34_1, this.d34_1, true)) {
    return false;
  }
  var _iterator__ex2g4s = pattern.a32_1.l();
  while (_iterator__ex2g4s.m()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.n();
    var patternName = _destruct__k2r9zo.wf();
    var patternValue = _destruct__k2r9zo.xf();
    var tmp;
    if (patternName === '*') {
      var tmp_0;
      if (patternValue === '*') {
        tmp_0 = true;
      } else {
        var tmp0 = this.a32_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_1;
          if (isInterface(tmp0, Collection)) {
            tmp_1 = tmp0.q();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s_0 = tmp0.l();
          while (_iterator__ex2g4s_0.m()) {
            var element = _iterator__ex2g4s_0.n();
            if (equals(element.c32_1, patternValue, true)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp_0 = tmp$ret$0;
      }
      tmp = tmp_0;
    } else {
      var value = this.h34(patternName);
      tmp = patternValue === '*' ? !(value == null) : equals(value, patternValue, true);
    }
    var matches = tmp;
    if (!matches) {
      return false;
    }
  }
  return true;
};
protoOf(ContentType).equals = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  if (other instanceof ContentType) {
    tmp_1 = equals(this.c34_1, other.c34_1, true);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = equals(this.d34_1, other.d34_1, true);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = equals_0(this.a32_1, other.a32_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(ContentType).hashCode = function () {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = this.c34_1.toLowerCase();
  var result = getStringHashCode(tmp$ret$1);
  var tmp = result;
  var tmp_0 = imul(31, result);
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = this.d34_1.toLowerCase();
  result = tmp + (tmp_0 + getStringHashCode(tmp$ret$3) | 0) | 0;
  result = result + imul(31, hashCode(this.a32_1)) | 0;
  return result;
};
function charset(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.h34('charset');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0;
    try {
      tmp_0 = forName(Charsets_getInstance(), tmp0_safe_receiver);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var exception = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function withCharset(_this__u8e3s4, charset) {
  return _this__u8e3s4.e34('charset', get_name(charset));
}
function BadContentTypeFormatException(value) {
  Exception_init_$Init$('Bad Content-Type format: ' + value, this);
  captureStack(this, BadContentTypeFormatException);
}
function withCharsetIfNeeded(_this__u8e3s4, charset) {
  var tmp;
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  if (!(_this__u8e3s4.c34_1.toLowerCase() === 'text')) {
    tmp = _this__u8e3s4;
  } else {
    tmp = _this__u8e3s4.e34('charset', get_name(charset));
  }
  return tmp;
}
function get_loweredPartNames() {
  _init_properties_Cookie_kt__ya8qpo();
  return loweredPartNames;
}
var loweredPartNames;
function get_clientCookieHeaderPattern() {
  _init_properties_Cookie_kt__ya8qpo();
  return clientCookieHeaderPattern;
}
var clientCookieHeaderPattern;
function get_cookieCharsShouldBeEscaped() {
  _init_properties_Cookie_kt__ya8qpo();
  return cookieCharsShouldBeEscaped;
}
var cookieCharsShouldBeEscaped;
function Cookie$Companion$$childSerializers$_anonymous__723bju() {
  return createSimpleEnumSerializer('io.ktor.http.CookieEncoding', values());
}
function Cookie$Companion$$childSerializers$_anonymous__723bju_0() {
  return new LinkedHashMapSerializer(StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()));
}
function Companion_0() {
  Companion_instance_0 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, Cookie$Companion$$childSerializers$_anonymous__723bju);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.i34_1 = [null, null, tmp_1, null, null, null, null, null, null, lazy(tmp_2, Cookie$Companion$$childSerializers$_anonymous__723bju_0)];
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 == null)
    new Companion_0();
  return Companion_instance_0;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.ktor.http.Cookie', this, 10);
  tmp0_serialDesc.k10('name', false);
  tmp0_serialDesc.k10('value', false);
  tmp0_serialDesc.k10('encoding', true);
  tmp0_serialDesc.k10('maxAge', true);
  tmp0_serialDesc.k10('expires', true);
  tmp0_serialDesc.k10('domain', true);
  tmp0_serialDesc.k10('path', true);
  tmp0_serialDesc.k10('secure', true);
  tmp0_serialDesc.k10('httpOnly', true);
  tmp0_serialDesc.k10('extensions', true);
  this.j34_1 = tmp0_serialDesc;
}
protoOf($serializer).k34 = function (encoder, value) {
  var tmp0_desc = this.j34_1;
  var tmp1_output = encoder.ss(tmp0_desc);
  var tmp2_cached = Companion_getInstance_1().i34_1;
  tmp1_output.hu(tmp0_desc, 0, value.l34_1);
  tmp1_output.hu(tmp0_desc, 1, value.m34_1);
  if (tmp1_output.pu(tmp0_desc, 2) ? true : !value.n34_1.equals(CookieEncoding_URI_ENCODING_getInstance())) {
    tmp1_output.ju(tmp0_desc, 2, tmp2_cached[2].w(), value.n34_1);
  }
  if (tmp1_output.pu(tmp0_desc, 3) ? true : !(value.o34_1 == null)) {
    tmp1_output.lu(tmp0_desc, 3, IntSerializer_getInstance(), value.o34_1);
  }
  if (tmp1_output.pu(tmp0_desc, 4) ? true : !(value.p34_1 == null)) {
    tmp1_output.lu(tmp0_desc, 4, $serializer_getInstance(), value.p34_1);
  }
  if (tmp1_output.pu(tmp0_desc, 5) ? true : !(value.q34_1 == null)) {
    tmp1_output.lu(tmp0_desc, 5, StringSerializer_getInstance(), value.q34_1);
  }
  if (tmp1_output.pu(tmp0_desc, 6) ? true : !(value.r34_1 == null)) {
    tmp1_output.lu(tmp0_desc, 6, StringSerializer_getInstance(), value.r34_1);
  }
  if (tmp1_output.pu(tmp0_desc, 7) ? true : !(value.s34_1 === false)) {
    tmp1_output.zt(tmp0_desc, 7, value.s34_1);
  }
  if (tmp1_output.pu(tmp0_desc, 8) ? true : !(value.t34_1 === false)) {
    tmp1_output.zt(tmp0_desc, 8, value.t34_1);
  }
  if (tmp1_output.pu(tmp0_desc, 9) ? true : !equals_0(value.u34_1, emptyMap())) {
    tmp1_output.ju(tmp0_desc, 9, tmp2_cached[9].w(), value.u34_1);
  }
  tmp1_output.ts(tmp0_desc);
};
protoOf($serializer).gp = function (encoder, value) {
  return this.k34(encoder, value instanceof Cookie ? value : THROW_CCE());
};
protoOf($serializer).hp = function (decoder) {
  var tmp0_desc = this.j34_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = false;
  var tmp12_local8 = false;
  var tmp13_local9 = null;
  var tmp14_input = decoder.ss(tmp0_desc);
  var tmp15_cached = Companion_getInstance_1().i34_1;
  if (tmp14_input.it()) {
    tmp4_local0 = tmp14_input.ct(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp14_input.ct(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp14_input.et(tmp0_desc, 2, tmp15_cached[2].w(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp14_input.gt(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp14_input.gt(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp14_input.gt(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp14_input.gt(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp14_input.us(tmp0_desc, 7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp14_input.us(tmp0_desc, 8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp14_input.et(tmp0_desc, 9, tmp15_cached[9].w(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp14_input.jt(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp14_input.ct(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp14_input.ct(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp14_input.et(tmp0_desc, 2, tmp15_cached[2].w(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp14_input.gt(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp14_input.gt(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp14_input.gt(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp14_input.gt(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp14_input.us(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp14_input.us(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp14_input.et(tmp0_desc, 9, tmp15_cached[9].w(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp14_input.ts(tmp0_desc);
  return Cookie_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
};
protoOf($serializer).fp = function () {
  return this.j34_1;
};
protoOf($serializer).z10 = function () {
  var tmp0_cached = Companion_getInstance_1().i34_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].w(), get_nullable(IntSerializer_getInstance()), get_nullable($serializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[9].w()];
};
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function Cookie_init_$Init$(seen0, name, value, encoding, maxAge, expires, domain, path, secure, httpOnly, extensions, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_0().j34_1);
  }
  $this.l34_1 = name;
  $this.m34_1 = value;
  if (0 === (seen0 & 4))
    $this.n34_1 = CookieEncoding_URI_ENCODING_getInstance();
  else
    $this.n34_1 = encoding;
  if (0 === (seen0 & 8))
    $this.o34_1 = null;
  else
    $this.o34_1 = maxAge;
  if (0 === (seen0 & 16))
    $this.p34_1 = null;
  else
    $this.p34_1 = expires;
  if (0 === (seen0 & 32))
    $this.q34_1 = null;
  else
    $this.q34_1 = domain;
  if (0 === (seen0 & 64))
    $this.r34_1 = null;
  else
    $this.r34_1 = path;
  if (0 === (seen0 & 128))
    $this.s34_1 = false;
  else
    $this.s34_1 = secure;
  if (0 === (seen0 & 256))
    $this.t34_1 = false;
  else
    $this.t34_1 = httpOnly;
  if (0 === (seen0 & 512))
    $this.u34_1 = emptyMap();
  else
    $this.u34_1 = extensions;
  return $this;
}
function Cookie_init_$Create$(seen0, name, value, encoding, maxAge, expires, domain, path, secure, httpOnly, extensions, serializationConstructorMarker) {
  return Cookie_init_$Init$(seen0, name, value, encoding, maxAge, expires, domain, path, secure, httpOnly, extensions, serializationConstructorMarker, objectCreate(protoOf(Cookie)));
}
function Cookie(name, value, encoding, maxAge, expires, domain, path, secure, httpOnly, extensions) {
  Companion_getInstance_1();
  encoding = encoding === VOID ? CookieEncoding_URI_ENCODING_getInstance() : encoding;
  maxAge = maxAge === VOID ? null : maxAge;
  expires = expires === VOID ? null : expires;
  domain = domain === VOID ? null : domain;
  path = path === VOID ? null : path;
  secure = secure === VOID ? false : secure;
  httpOnly = httpOnly === VOID ? false : httpOnly;
  extensions = extensions === VOID ? emptyMap() : extensions;
  this.l34_1 = name;
  this.m34_1 = value;
  this.n34_1 = encoding;
  this.o34_1 = maxAge;
  this.p34_1 = expires;
  this.q34_1 = domain;
  this.r34_1 = path;
  this.s34_1 = secure;
  this.t34_1 = httpOnly;
  this.u34_1 = extensions;
}
protoOf(Cookie).v34 = function (name, value, encoding, maxAge, expires, domain, path, secure, httpOnly, extensions) {
  return new Cookie(name, value, encoding, maxAge, expires, domain, path, secure, httpOnly, extensions);
};
protoOf(Cookie).w34 = function (name, value, encoding, maxAge, expires, domain, path, secure, httpOnly, extensions, $super) {
  name = name === VOID ? this.l34_1 : name;
  value = value === VOID ? this.m34_1 : value;
  encoding = encoding === VOID ? this.n34_1 : encoding;
  maxAge = maxAge === VOID ? this.o34_1 : maxAge;
  expires = expires === VOID ? this.p34_1 : expires;
  domain = domain === VOID ? this.q34_1 : domain;
  path = path === VOID ? this.r34_1 : path;
  secure = secure === VOID ? this.s34_1 : secure;
  httpOnly = httpOnly === VOID ? this.t34_1 : httpOnly;
  extensions = extensions === VOID ? this.u34_1 : extensions;
  return $super === VOID ? this.v34(name, value, encoding, maxAge, expires, domain, path, secure, httpOnly, extensions) : $super.v34.call(this, name, value, encoding, maxAge, expires, domain, path, secure, httpOnly, extensions);
};
protoOf(Cookie).toString = function () {
  return 'Cookie(name=' + this.l34_1 + ', value=' + this.m34_1 + ', encoding=' + this.n34_1.toString() + ', maxAge=' + this.o34_1 + ', expires=' + toString_1(this.p34_1) + ', domain=' + this.q34_1 + ', path=' + this.r34_1 + ', secure=' + this.s34_1 + ', httpOnly=' + this.t34_1 + ', extensions=' + toString(this.u34_1) + ')';
};
protoOf(Cookie).hashCode = function () {
  var result = getStringHashCode(this.l34_1);
  result = imul(result, 31) + getStringHashCode(this.m34_1) | 0;
  result = imul(result, 31) + this.n34_1.hashCode() | 0;
  result = imul(result, 31) + (this.o34_1 == null ? 0 : this.o34_1) | 0;
  result = imul(result, 31) + (this.p34_1 == null ? 0 : this.p34_1.hashCode()) | 0;
  result = imul(result, 31) + (this.q34_1 == null ? 0 : getStringHashCode(this.q34_1)) | 0;
  result = imul(result, 31) + (this.r34_1 == null ? 0 : getStringHashCode(this.r34_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.s34_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.t34_1) | 0;
  result = imul(result, 31) + hashCode(this.u34_1) | 0;
  return result;
};
protoOf(Cookie).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Cookie))
    return false;
  if (!(this.l34_1 === other.l34_1))
    return false;
  if (!(this.m34_1 === other.m34_1))
    return false;
  if (!this.n34_1.equals(other.n34_1))
    return false;
  if (!(this.o34_1 == other.o34_1))
    return false;
  if (!equals_0(this.p34_1, other.p34_1))
    return false;
  if (!(this.q34_1 == other.q34_1))
    return false;
  if (!(this.r34_1 == other.r34_1))
    return false;
  if (!(this.s34_1 === other.s34_1))
    return false;
  if (!(this.t34_1 === other.t34_1))
    return false;
  if (!equals_0(this.u34_1, other.u34_1))
    return false;
  return true;
};
function parseClientCookiesHeader(cookiesHeader, skipEscaped) {
  skipEscaped = skipEscaped === VOID ? true : skipEscaped;
  _init_properties_Cookie_kt__ya8qpo();
  var tmp = get_clientCookieHeaderPattern().tc(cookiesHeader);
  var tmp_0 = map(tmp, parseClientCookiesHeader$lambda);
  var tmp_1 = filter(tmp_0, parseClientCookiesHeader$lambda_0(skipEscaped));
  return toMap(map(tmp_1, parseClientCookiesHeader$lambda_1));
}
var CookieEncoding_RAW_instance;
var CookieEncoding_DQUOTES_instance;
var CookieEncoding_URI_ENCODING_instance;
var CookieEncoding_BASE64_ENCODING_instance;
function values() {
  return [CookieEncoding_RAW_getInstance(), CookieEncoding_DQUOTES_getInstance(), CookieEncoding_URI_ENCODING_getInstance(), CookieEncoding_BASE64_ENCODING_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'RAW':
      return CookieEncoding_RAW_getInstance();
    case 'DQUOTES':
      return CookieEncoding_DQUOTES_getInstance();
    case 'URI_ENCODING':
      return CookieEncoding_URI_ENCODING_getInstance();
    case 'BASE64_ENCODING':
      return CookieEncoding_BASE64_ENCODING_getInstance();
    default:
      CookieEncoding_initEntries();
      THROW_IAE('No enum constant io.ktor.http.CookieEncoding.' + value);
      break;
  }
}
var CookieEncoding_entriesInitialized;
function CookieEncoding_initEntries() {
  if (CookieEncoding_entriesInitialized)
    return Unit_instance;
  CookieEncoding_entriesInitialized = true;
  CookieEncoding_RAW_instance = new CookieEncoding('RAW', 0);
  CookieEncoding_DQUOTES_instance = new CookieEncoding('DQUOTES', 1);
  CookieEncoding_URI_ENCODING_instance = new CookieEncoding('URI_ENCODING', 2);
  CookieEncoding_BASE64_ENCODING_instance = new CookieEncoding('BASE64_ENCODING', 3);
}
function CookieEncoding(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function renderCookieHeader(cookie) {
  _init_properties_Cookie_kt__ya8qpo();
  // Inline function 'kotlin.with' call
  return cookie.l34_1 + '=' + encodeCookieValue(cookie.m34_1, cookie.n34_1);
}
function parseServerSetCookieHeader(cookiesHeader) {
  _init_properties_Cookie_kt__ya8qpo();
  var asMap = parseClientCookiesHeader(cookiesHeader, false);
  var tmp0 = asMap.u();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.first' call
    var _iterator__ex2g4s = tmp0.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      if (!startsWith_0(element.v(), '$')) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    throw NoSuchElementException_init_$Create$('Collection contains no element matching the predicate.');
  }
  var first = tmp$ret$1;
  var tmp0_safe_receiver = asMap.h2('$x-enc');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = valueOf(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var encoding = tmp1_elvis_lhs == null ? CookieEncoding_RAW_getInstance() : tmp1_elvis_lhs;
  // Inline function 'kotlin.collections.mapKeys' call
  // Inline function 'kotlin.collections.mapKeysTo' call
  var destination = LinkedHashMap_init_$Create$(mapCapacity(asMap.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_0 = asMap.u().l();
  while (_iterator__ex2g4s_0.m()) {
    var element_0 = _iterator__ex2g4s_0.n();
    var tmp_0 = toLowerCasePreservingASCIIRules(element_0.v());
    var tmp$ret$5 = element_0.w();
    destination.a2(tmp_0, tmp$ret$5);
  }
  var loweredMap = destination;
  var tmp_1 = first.v();
  var tmp_2 = decodeCookieValue(first.w(), encoding);
  var tmp2_safe_receiver = loweredMap.h2('max-age');
  var tmp_3 = tmp2_safe_receiver == null ? null : toIntClamping(tmp2_safe_receiver);
  var tmp3_safe_receiver = loweredMap.h2('expires');
  var tmp_4 = tmp3_safe_receiver == null ? null : fromCookieToGmtDate(tmp3_safe_receiver);
  var tmp_5 = loweredMap.h2('domain');
  var tmp_6 = loweredMap.h2('path');
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  var tmp_7 = (isInterface(loweredMap, KtMap) ? loweredMap : THROW_CCE()).f2('secure');
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  var key = 'httponly';
  var tmp_8 = (isInterface(loweredMap, KtMap) ? loweredMap : THROW_CCE()).f2(key);
  // Inline function 'kotlin.collections.filterKeys' call
  var result = LinkedHashMap_init_$Create$_0();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_1 = asMap.u().l();
  while (_iterator__ex2g4s_1.m()) {
    var entry = _iterator__ex2g4s_1.n();
    var it = entry.v();
    if (!get_loweredPartNames().q1(toLowerCasePreservingASCIIRules(it)) && !(it === first.v())) {
      result.a2(entry.v(), entry.w());
    }
  }
  return new Cookie(tmp_1, tmp_2, encoding, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, result);
}
function encodeCookieValue(value, encoding) {
  _init_properties_Cookie_kt__ya8qpo();
  var tmp;
  switch (encoding.j2_1) {
    case 0:
      tmp = value;
      break;
    case 1:
      var tmp_0;
      if (contains(value, _Char___init__impl__6a9atx(34))) {
        throw IllegalArgumentException_init_$Create$('The cookie value contains characters that cannot be encoded in DQUOTES format. Consider URL_ENCODING mode');
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.text.any' call
          var inductionVariable = 0;
          while (inductionVariable < charSequenceLength(value)) {
            var element = charSequenceGet(value, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            if (shouldEscapeInCookies(element)) {
              tmp$ret$1 = true;
              break $l$block;
            }
          }
          tmp$ret$1 = false;
        }
        if (tmp$ret$1) {
          tmp_0 = '"' + value + '"';
        } else {
          tmp_0 = value;
        }
      }

      tmp = tmp_0;
      break;
    case 3:
      tmp = encodeBase64(value);
      break;
    case 2:
      tmp = encodeURLParameter(value, true);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function decodeCookieValue(encodedValue, encoding) {
  _init_properties_Cookie_kt__ya8qpo();
  var tmp;
  switch (encoding.j2_1) {
    case 0:
    case 1:
      var tmp_0;
      var tmp_1;
      // Inline function 'kotlin.text.trimStart' call

      var tmp$ret$0 = toString(trimStart(isCharSequence(encodedValue) ? encodedValue : THROW_CCE()));
      if (startsWith_0(tmp$ret$0, '"')) {
        // Inline function 'kotlin.text.trimEnd' call
        var tmp$ret$1 = toString(trimEnd(isCharSequence(encodedValue) ? encodedValue : THROW_CCE()));
        tmp_1 = endsWith(tmp$ret$1, '"');
      } else {
        tmp_1 = false;
      }

      if (tmp_1) {
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$2 = toString(trim(isCharSequence(encodedValue) ? encodedValue : THROW_CCE()));
        tmp_0 = removeSurrounding(tmp$ret$2, '"');
      } else {
        tmp_0 = encodedValue;
      }

      tmp = tmp_0;
      break;
    case 2:
      tmp = decodeURLQueryComponent(encodedValue, VOID, VOID, true);
      break;
    case 3:
      tmp = decodeBase64String(encodedValue);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toIntClamping(_this__u8e3s4) {
  _init_properties_Cookie_kt__ya8qpo();
  return convertToInt(coerceIn(toLong(_this__u8e3s4), 0n, 2147483647n));
}
function shouldEscapeInCookies(_this__u8e3s4) {
  _init_properties_Cookie_kt__ya8qpo();
  return isWhitespace(_this__u8e3s4) || Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(32)) < 0 || get_cookieCharsShouldBeEscaped().q1(new Char(_this__u8e3s4));
}
function parseClientCookiesHeader$lambda(it) {
  _init_properties_Cookie_kt__ya8qpo();
  var tmp0_safe_receiver = it.hd().p(2);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.uc_1;
  var tmp = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  var tmp2_safe_receiver = it.hd().p(4);
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.uc_1;
  return to(tmp, tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs);
}
function parseClientCookiesHeader$lambda_0($skipEscaped) {
  return function (it) {
    return !$skipEscaped || !startsWith_0(it.uf_1, '$');
  };
}
function parseClientCookiesHeader$lambda_1(cookie) {
  _init_properties_Cookie_kt__ya8qpo();
  var tmp;
  if (startsWith_0(cookie.vf_1, '"') && endsWith(cookie.vf_1, '"')) {
    tmp = cookie.en(VOID, removeSurrounding(cookie.vf_1, '"'));
  } else {
    tmp = cookie;
  }
  return tmp;
}
function CookieEncoding_RAW_getInstance() {
  CookieEncoding_initEntries();
  return CookieEncoding_RAW_instance;
}
function CookieEncoding_DQUOTES_getInstance() {
  CookieEncoding_initEntries();
  return CookieEncoding_DQUOTES_instance;
}
function CookieEncoding_URI_ENCODING_getInstance() {
  CookieEncoding_initEntries();
  return CookieEncoding_URI_ENCODING_instance;
}
function CookieEncoding_BASE64_ENCODING_getInstance() {
  CookieEncoding_initEntries();
  return CookieEncoding_BASE64_ENCODING_instance;
}
var properties_initialized_Cookie_kt_v547l2;
function _init_properties_Cookie_kt__ya8qpo() {
  if (!properties_initialized_Cookie_kt_v547l2) {
    properties_initialized_Cookie_kt_v547l2 = true;
    loweredPartNames = setOf(['max-age', 'expires', 'domain', 'path', 'secure', 'httponly', '$x-enc']);
    // Inline function 'kotlin.text.toRegex' call
    var this_0 = '(^|;)\\s*([^;=\\{\\}\\s]+)\\s*(=\\s*("[^"]*"|[^;]*))?';
    clientCookieHeaderPattern = Regex_init_$Create$(this_0);
    cookieCharsShouldBeEscaped = setOf([new Char(_Char___init__impl__6a9atx(59)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(34))]);
  }
}
function checkFieldNotNull($this, source, name, field) {
  if (null == field) {
    throw new InvalidCookieDateException(source, 'Could not find ' + name);
  }
}
function checkRequirement($this, source, requirement, msg) {
  if (!requirement) {
    throw new InvalidCookieDateException(source, msg());
  }
}
function CookieDateParser$parse$lambda(it) {
  return isDelimiter(it.e1_1);
}
function CookieDateParser$parse$lambda_0(it) {
  return isNonDelimiter(it.e1_1);
}
function CookieDateParser$parse$lambda_1(it) {
  return isNonDelimiter(it.e1_1);
}
function CookieDateParser$parse$lambda_2(it) {
  return isDelimiter(it.e1_1);
}
function CookieDateParser$parse$lambda_3() {
  return 'day-of-month not in [1,31]';
}
function CookieDateParser$parse$lambda_4() {
  return 'year >= 1601';
}
function CookieDateParser$parse$lambda_5() {
  return 'hours > 23';
}
function CookieDateParser$parse$lambda_6() {
  return 'minutes > 59';
}
function CookieDateParser$parse$lambda_7() {
  return 'seconds > 59';
}
function CookieDateParser() {
}
protoOf(CookieDateParser).in = function (source) {
  var lexer = new StringLexer(source);
  var builder = new CookieDateBuilder();
  lexer.z34(CookieDateParser$parse$lambda);
  while (lexer.a35()) {
    if (lexer.b35(CookieDateParser$parse$lambda_0)) {
      // Inline function 'io.ktor.http.StringLexer.capture' call
      var start = lexer.y34_1;
      lexer.z34(CookieDateParser$parse$lambda_1);
      var token = substring(lexer.x34_1, start, lexer.y34_1);
      handleToken(builder, token);
      lexer.z34(CookieDateParser$parse$lambda_2);
    }
  }
  var tmp0_subject = builder.h35_1;
  // Inline function 'kotlin.ranges.contains' call
  var this_0 = numberRangeToNumber(70, 99);
  if (!(tmp0_subject == null) && this_0.dj(tmp0_subject))
    builder.h35_1 = ensureNotNull(builder.h35_1) + 1900 | 0;
  else {
    // Inline function 'kotlin.ranges.contains' call
    var this_1 = numberRangeToNumber(0, 69);
    if (!(tmp0_subject == null) && this_1.dj(tmp0_subject))
      builder.h35_1 = ensureNotNull(builder.h35_1) + 2000 | 0;
  }
  checkFieldNotNull(this, source, 'day-of-month', builder.f35_1);
  checkFieldNotNull(this, source, 'month', builder.g35_1);
  checkFieldNotNull(this, source, 'year', builder.h35_1);
  checkFieldNotNull(this, source, 'time', builder.e35_1);
  checkFieldNotNull(this, source, 'time', builder.d35_1);
  checkFieldNotNull(this, source, 'time', builder.c35_1);
  var tmp0 = numberRangeToNumber(1, 31);
  // Inline function 'kotlin.ranges.contains' call
  var element = builder.f35_1;
  var tmp = !(element == null) && tmp0.dj(element);
  checkRequirement(this, source, tmp, CookieDateParser$parse$lambda_3);
  var tmp_0 = ensureNotNull(builder.h35_1) >= 1601;
  checkRequirement(this, source, tmp_0, CookieDateParser$parse$lambda_4);
  var tmp_1 = ensureNotNull(builder.e35_1) <= 23;
  checkRequirement(this, source, tmp_1, CookieDateParser$parse$lambda_5);
  var tmp_2 = ensureNotNull(builder.d35_1) <= 59;
  checkRequirement(this, source, tmp_2, CookieDateParser$parse$lambda_6);
  var tmp_3 = ensureNotNull(builder.c35_1) <= 59;
  checkRequirement(this, source, tmp_3, CookieDateParser$parse$lambda_7);
  return builder.z1m();
};
function InvalidCookieDateException(data, reason) {
  IllegalStateException_init_$Init$('Failed to parse date string: "' + data + '". Reason: "' + reason + '"', this);
  captureStack(this, InvalidCookieDateException);
}
function StringLexer(source) {
  this.x34_1 = source;
  this.y34_1 = 0;
}
protoOf(StringLexer).a35 = function () {
  return this.y34_1 < this.x34_1.length;
};
protoOf(StringLexer).b35 = function (predicate) {
  return this.y34_1 < this.x34_1.length && predicate(new Char(charCodeAt(this.x34_1, this.y34_1)));
};
protoOf(StringLexer).i35 = function (predicate) {
  // Inline function 'kotlin.also' call
  var this_0 = this.b35(predicate);
  if (this_0) {
    this.y34_1 = this.y34_1 + 1 | 0;
  }
  return this_0;
};
protoOf(StringLexer).z34 = function (predicate) {
  if (!this.b35(predicate))
    return false;
  while (this.b35(predicate)) {
    this.y34_1 = this.y34_1 + 1 | 0;
  }
  return true;
};
function CookieDateBuilder() {
  this.c35_1 = null;
  this.d35_1 = null;
  this.e35_1 = null;
  this.f35_1 = null;
  this.g35_1 = null;
  this.h35_1 = null;
}
protoOf(CookieDateBuilder).z1m = function () {
  return GMTDate(ensureNotNull(this.c35_1), ensureNotNull(this.d35_1), ensureNotNull(this.e35_1), ensureNotNull(this.f35_1), ensureNotNull(this.g35_1), ensureNotNull(this.h35_1));
};
function isDelimiter(_this__u8e3s4) {
  return _this__u8e3s4 === _Char___init__impl__6a9atx(9) || (_Char___init__impl__6a9atx(32) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(47) : false) || (_Char___init__impl__6a9atx(59) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(64) : false) || (_Char___init__impl__6a9atx(91) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(96) : false) || (_Char___init__impl__6a9atx(123) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(126) : false);
}
function isNonDelimiter(_this__u8e3s4) {
  return (_Char___init__impl__6a9atx(0) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(8) : false) || (_Char___init__impl__6a9atx(10) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(31) : false) || (_Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false) || _this__u8e3s4 === _Char___init__impl__6a9atx(58) || (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) || (_Char___init__impl__6a9atx(65) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(90) : false) || (_Char___init__impl__6a9atx(127) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(255) : false);
}
function handleToken(_this__u8e3s4, token) {
  if (_this__u8e3s4.e35_1 == null || _this__u8e3s4.d35_1 == null || _this__u8e3s4.c35_1 == null) {
    $l$block_3: {
      // Inline function 'io.ktor.http.tryParseTime' call
      var lexer = new StringLexer(token);
      // Inline function 'io.ktor.http.StringLexer.capture' call
      var start = lexer.y34_1;
      // Inline function 'io.ktor.http.otherwise' call
      if (!lexer.i35(handleToken$lambda)) {
        break $l$block_3;
      }
      lexer.i35(handleToken$lambda_0);
      var tmp$ret$3 = substring(lexer.x34_1, start, lexer.y34_1);
      var hour = toInt(tmp$ret$3);
      // Inline function 'io.ktor.http.otherwise' call
      if (!lexer.i35(handleToken$lambda_1)) {
        break $l$block_3;
      }
      // Inline function 'io.ktor.http.StringLexer.capture' call
      var start_0 = lexer.y34_1;
      // Inline function 'io.ktor.http.otherwise' call
      if (!lexer.i35(handleToken$lambda_2)) {
        break $l$block_3;
      }
      lexer.i35(handleToken$lambda_3);
      var tmp$ret$7 = substring(lexer.x34_1, start_0, lexer.y34_1);
      var minute = toInt(tmp$ret$7);
      // Inline function 'io.ktor.http.otherwise' call
      if (!lexer.i35(handleToken$lambda_4)) {
        break $l$block_3;
      }
      // Inline function 'io.ktor.http.StringLexer.capture' call
      var start_1 = lexer.y34_1;
      // Inline function 'io.ktor.http.otherwise' call
      if (!lexer.i35(handleToken$lambda_5)) {
        break $l$block_3;
      }
      lexer.i35(handleToken$lambda_6);
      var tmp$ret$11 = substring(lexer.x34_1, start_1, lexer.y34_1);
      var second = toInt(tmp$ret$11);
      if (lexer.i35(handleToken$lambda_7)) {
        lexer.z34(handleToken$lambda_8);
      }
      _this__u8e3s4.e35_1 = hour;
      _this__u8e3s4.d35_1 = minute;
      _this__u8e3s4.c35_1 = second;
      return Unit_instance;
    }
  }
  if (_this__u8e3s4.f35_1 == null) {
    $l$block_4: {
      // Inline function 'io.ktor.http.tryParseDayOfMonth' call
      var lexer_0 = new StringLexer(token);
      // Inline function 'io.ktor.http.StringLexer.capture' call
      var start_2 = lexer_0.y34_1;
      // Inline function 'io.ktor.http.otherwise' call
      if (!lexer_0.i35(handleToken$lambda_9)) {
        break $l$block_4;
      }
      lexer_0.i35(handleToken$lambda_10);
      var tmp$ret$15 = substring(lexer_0.x34_1, start_2, lexer_0.y34_1);
      var day = toInt(tmp$ret$15);
      if (lexer_0.i35(handleToken$lambda_11)) {
        lexer_0.z34(handleToken$lambda_12);
      }
      _this__u8e3s4.f35_1 = day;
      return Unit_instance;
    }
  }
  if (_this__u8e3s4.g35_1 == null) {
    $l$block_6: {
      // Inline function 'io.ktor.http.tryParseMonth' call
      if (token.length < 3) {
        break $l$block_6;
      }
      var _iterator__ex2g4s = get_entries().l();
      while (_iterator__ex2g4s.m()) {
        var month = _iterator__ex2g4s.n();
        if (startsWith_0(token, month.r2y_1, true)) {
          _this__u8e3s4.g35_1 = month;
          return Unit_instance;
        }
      }
    }
  }
  if (_this__u8e3s4.h35_1 == null) {
    $l$block_7: {
      // Inline function 'io.ktor.http.tryParseYear' call
      var lexer_1 = new StringLexer(token);
      // Inline function 'io.ktor.http.StringLexer.capture' call
      var start_3 = lexer_1.y34_1;
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < 2)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'io.ktor.http.otherwise' call
          if (!lexer_1.i35(handleToken$lambda_13)) {
            break $l$block_7;
          }
        }
         while (inductionVariable < 2);
      // Inline function 'kotlin.repeat' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < 2)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          lexer_1.i35(handleToken$lambda_14);
        }
         while (inductionVariable_0 < 2);
      var tmp$ret$24 = substring(lexer_1.x34_1, start_3, lexer_1.y34_1);
      var year = toInt(tmp$ret$24);
      if (lexer_1.i35(handleToken$lambda_15)) {
        lexer_1.z34(handleToken$lambda_16);
      }
      _this__u8e3s4.h35_1 = year;
      return Unit_instance;
    }
  }
}
function isDigit(_this__u8e3s4) {
  return _Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false;
}
function isNonDigit(_this__u8e3s4) {
  return (_Char___init__impl__6a9atx(0) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(47) : false) || (_Char___init__impl__6a9atx(74) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(255) : false);
}
function isOctet(_this__u8e3s4) {
  return _Char___init__impl__6a9atx(0) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(255) : false;
}
function handleToken$lambda(it) {
  return isDigit(it.e1_1);
}
function handleToken$lambda_0(it) {
  return isDigit(it.e1_1);
}
function handleToken$lambda_1(it) {
  return equals_0(it, new Char(_Char___init__impl__6a9atx(58)));
}
function handleToken$lambda_2(it) {
  return isDigit(it.e1_1);
}
function handleToken$lambda_3(it) {
  return isDigit(it.e1_1);
}
function handleToken$lambda_4(it) {
  return equals_0(it, new Char(_Char___init__impl__6a9atx(58)));
}
function handleToken$lambda_5(it) {
  return isDigit(it.e1_1);
}
function handleToken$lambda_6(it) {
  return isDigit(it.e1_1);
}
function handleToken$lambda_7(it) {
  return isNonDigit(it.e1_1);
}
function handleToken$lambda_8(it) {
  return isOctet(it.e1_1);
}
function handleToken$lambda_9(it) {
  return isDigit(it.e1_1);
}
function handleToken$lambda_10(it) {
  return isDigit(it.e1_1);
}
function handleToken$lambda_11(it) {
  return isNonDigit(it.e1_1);
}
function handleToken$lambda_12(it) {
  return isOctet(it.e1_1);
}
function handleToken$lambda_13(it) {
  return isDigit(it.e1_1);
}
function handleToken$lambda_14(it) {
  return isDigit(it.e1_1);
}
function handleToken$lambda_15(it) {
  return isNonDigit(it.e1_1);
}
function handleToken$lambda_16(it) {
  return isOctet(it.e1_1);
}
function get_HTTP_DATE_FORMATS() {
  _init_properties_DateUtils_kt__b7z3g1();
  return HTTP_DATE_FORMATS;
}
var HTTP_DATE_FORMATS;
function fromCookieToGmtDate(_this__u8e3s4) {
  _init_properties_DateUtils_kt__b7z3g1();
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.with' call
  var $this$with = toString(trim(isCharSequence(_this__u8e3s4) ? _this__u8e3s4 : THROW_CCE()));
  try {
    var parser = new CookieDateParser();
    return parser.in($this$with);
  } catch ($p) {
    if ($p instanceof InvalidCookieDateException) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  return fromHttpToGmtDate($this$with);
}
function fromHttpToGmtDate(_this__u8e3s4) {
  _init_properties_DateUtils_kt__b7z3g1();
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.with' call
  var $this$with = toString(trim(isCharSequence(_this__u8e3s4) ? _this__u8e3s4 : THROW_CCE()));
  var _iterator__ex2g4s = get_HTTP_DATE_FORMATS().l();
  while (_iterator__ex2g4s.m()) {
    var format = _iterator__ex2g4s.n();
    try {
      var parser = new GMTDateParser(format);
      return parser.in(_this__u8e3s4);
    } catch ($p) {
      if ($p instanceof InvalidDateStringException) {
        var _unused_var__etf5q3 = $p;
      } else {
        throw $p;
      }
    }
  }
  var message = 'Failed to parse date: ' + $this$with;
  throw IllegalStateException_init_$Create$(toString(message));
}
var properties_initialized_DateUtils_kt_j3k3il;
function _init_properties_DateUtils_kt__b7z3g1() {
  if (!properties_initialized_DateUtils_kt_j3k3il) {
    properties_initialized_DateUtils_kt_j3k3il = true;
    HTTP_DATE_FORMATS = listOf(['***, dd MMM YYYY hh:mm:ss zzz', '****, dd-MMM-YYYY hh:mm:ss zzz', '*** MMM d hh:mm:ss YYYY', '***, dd-MMM-YYYY hh:mm:ss zzz', '***, dd-MMM-YYYY hh-mm-ss zzz', '***, dd MMM YYYY hh:mm:ss zzz', '*** dd-MMM-YYYY hh:mm:ss zzz', '*** dd MMM YYYY hh:mm:ss zzz', '*** dd-MMM-YYYY hh-mm-ss zzz', '***,dd-MMM-YYYY hh:mm:ss zzz', '*** MMM d YYYY hh:mm:ss zzz']);
  }
}
function get_HeaderFieldValueSeparators() {
  _init_properties_HeaderValueWithParameters_kt__z6luvy();
  return HeaderFieldValueSeparators;
}
var HeaderFieldValueSeparators;
function Companion_1() {
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
function HeaderValueWithParameters(content, parameters) {
  parameters = parameters === VOID ? emptyList() : parameters;
  this.z31_1 = content;
  this.a32_1 = parameters;
}
protoOf(HeaderValueWithParameters).h34 = function (name) {
  var inductionVariable = 0;
  var last = get_lastIndex(this.a32_1);
  if (inductionVariable <= last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var parameter = this.a32_1.p(index);
      if (equals(parameter.b32_1, name, true)) {
        return parameter.c32_1;
      }
    }
     while (!(index === last));
  return null;
};
protoOf(HeaderValueWithParameters).toString = function () {
  var tmp;
  if (this.a32_1.q()) {
    tmp = this.z31_1;
  } else {
    var tmp_0 = this.z31_1.length;
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = this.a32_1.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      var tmp_1 = sum;
      sum = tmp_1 + ((element.b32_1.length + element.c32_1.length | 0) + 3 | 0) | 0;
    }
    var size = tmp_0 + sum | 0;
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_0(size);
    this_0.k7(this.z31_1);
    var inductionVariable = 0;
    var last = get_lastIndex(this.a32_1);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element_0 = this.a32_1.p(index);
        this_0.k7('; ');
        this_0.k7(element_0.b32_1);
        this_0.k7('=');
        // Inline function 'io.ktor.http.escapeIfNeededTo' call
        var this_1 = element_0.c32_1;
        if (needQuotes(this_1))
          this_0.k7(quote(this_1));
        else
          this_0.k7(this_1);
      }
       while (!(index === last));
    tmp = this_0.toString();
  }
  return tmp;
};
function needQuotes(_this__u8e3s4) {
  _init_properties_HeaderValueWithParameters_kt__z6luvy();
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(_this__u8e3s4) === 0)
    return true;
  if (isQuoted(_this__u8e3s4))
    return false;
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  while (inductionVariable < last) {
    var element = charCodeAt(_this__u8e3s4, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (get_HeaderFieldValueSeparators().q1(new Char(element)))
      return true;
  }
  return false;
}
function quote(_this__u8e3s4) {
  _init_properties_HeaderValueWithParameters_kt__z6luvy();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  quoteTo(_this__u8e3s4, this_0);
  return this_0.toString();
}
function isQuoted(_this__u8e3s4) {
  _init_properties_HeaderValueWithParameters_kt__z6luvy();
  if (_this__u8e3s4.length < 2) {
    return false;
  }
  if (!(first(_this__u8e3s4) === _Char___init__impl__6a9atx(34)) || !(last_0(_this__u8e3s4) === _Char___init__impl__6a9atx(34))) {
    return false;
  }
  var startIndex = 1;
  $l$loop: do {
    var index = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(34), startIndex);
    if (index === get_lastIndex_0(_this__u8e3s4)) {
      break $l$loop;
    }
    var slashesCount = 0;
    var slashIndex = index - 1 | 0;
    while (charCodeAt(_this__u8e3s4, slashIndex) === _Char___init__impl__6a9atx(92)) {
      slashesCount = slashesCount + 1 | 0;
      slashIndex = slashIndex - 1 | 0;
    }
    if ((slashesCount % 2 | 0) === 0) {
      return false;
    }
    startIndex = index + 1 | 0;
  }
   while (startIndex < _this__u8e3s4.length);
  return true;
}
function quoteTo(_this__u8e3s4, out) {
  _init_properties_HeaderValueWithParameters_kt__z6luvy();
  out.k7('"');
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  while (inductionVariable < last) {
    var element = charCodeAt(_this__u8e3s4, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    var ch = element;
    if (ch === _Char___init__impl__6a9atx(92))
      out.k7('\\\\');
    else if (ch === _Char___init__impl__6a9atx(10))
      out.k7('\\n');
    else if (ch === _Char___init__impl__6a9atx(13))
      out.k7('\\r');
    else if (ch === _Char___init__impl__6a9atx(9))
      out.k7('\\t');
    else if (ch === _Char___init__impl__6a9atx(34))
      out.k7('\\"');
    else
      out.l7(ch);
  }
  out.k7('"');
}
var properties_initialized_HeaderValueWithParameters_kt_yu5xg;
function _init_properties_HeaderValueWithParameters_kt__z6luvy() {
  if (!properties_initialized_HeaderValueWithParameters_kt_yu5xg) {
    properties_initialized_HeaderValueWithParameters_kt_yu5xg = true;
    HeaderFieldValueSeparators = setOf([new Char(_Char___init__impl__6a9atx(40)), new Char(_Char___init__impl__6a9atx(41)), new Char(_Char___init__impl__6a9atx(60)), new Char(_Char___init__impl__6a9atx(62)), new Char(_Char___init__impl__6a9atx(64)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(59)), new Char(_Char___init__impl__6a9atx(58)), new Char(_Char___init__impl__6a9atx(92)), new Char(_Char___init__impl__6a9atx(34)), new Char(_Char___init__impl__6a9atx(47)), new Char(_Char___init__impl__6a9atx(91)), new Char(_Char___init__impl__6a9atx(93)), new Char(_Char___init__impl__6a9atx(63)), new Char(_Char___init__impl__6a9atx(61)), new Char(_Char___init__impl__6a9atx(123)), new Char(_Char___init__impl__6a9atx(125)), new Char(_Char___init__impl__6a9atx(32)), new Char(_Char___init__impl__6a9atx(9)), new Char(_Char___init__impl__6a9atx(10)), new Char(_Char___init__impl__6a9atx(13))]);
  }
}
function HeadersBuilder(size) {
  size = size === VOID ? 8 : size;
  StringValuesBuilderImpl.call(this, true, size);
}
protoOf(HeadersBuilder).z1m = function () {
  return new HeadersImpl(this.a2x_1);
};
protoOf(HeadersBuilder).b2x = function (name) {
  protoOf(StringValuesBuilderImpl).b2x.call(this, name);
  HttpHeaders_getInstance().i39(name);
};
protoOf(HeadersBuilder).h2x = function (value) {
  protoOf(StringValuesBuilderImpl).h2x.call(this, value);
  HttpHeaders_getInstance().j39(value);
};
function Companion_2() {
  Companion_instance_2 = this;
  this.k39_1 = EmptyHeaders_instance;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 == null)
    new Companion_2();
  return Companion_instance_2;
}
function headersOf(name, value) {
  return new HeadersSingleImpl(name, listOf_0(value));
}
function HeadersImpl(values) {
  values = values === VOID ? emptyMap() : values;
  StringValuesImpl.call(this, true, values);
}
protoOf(HeadersImpl).toString = function () {
  return 'Headers ' + toString(this.x2w());
};
function EmptyHeaders() {
}
protoOf(EmptyHeaders).c2x = function () {
  return true;
};
protoOf(EmptyHeaders).d2x = function (name) {
  return null;
};
protoOf(EmptyHeaders).f2x = function () {
  return emptySet();
};
protoOf(EmptyHeaders).x2w = function () {
  return emptySet();
};
protoOf(EmptyHeaders).q = function () {
  return true;
};
protoOf(EmptyHeaders).toString = function () {
  return 'Headers ' + toString(this.x2w());
};
var EmptyHeaders_instance;
function EmptyHeaders_getInstance() {
  return EmptyHeaders_instance;
}
function HeadersSingleImpl(name, values) {
  StringValuesSingleImpl.call(this, true, name, values);
}
protoOf(HeadersSingleImpl).toString = function () {
  return 'Headers ' + toString(this.x2w());
};
function HeaderValue(value, params) {
  params = params === VOID ? emptyList() : params;
  this.f32_1 = value;
  this.g32_1 = params;
  var tmp = this;
  var tmp0 = this.g32_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      if (element.b32_1 === 'q') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c32_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    if (0.0 <= tmp2_safe_receiver ? tmp2_safe_receiver <= 1.0 : false) {
      tmp_1 = tmp2_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  var tmp3_elvis_lhs = tmp_0;
  tmp.h32_1 = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
}
protoOf(HeaderValue).wf = function () {
  return this.f32_1;
};
protoOf(HeaderValue).toString = function () {
  return 'HeaderValue(value=' + this.f32_1 + ', params=' + toString(this.g32_1) + ')';
};
protoOf(HeaderValue).hashCode = function () {
  var result = getStringHashCode(this.f32_1);
  result = imul(result, 31) + hashCode(this.g32_1) | 0;
  return result;
};
protoOf(HeaderValue).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof HeaderValue))
    return false;
  if (!(this.f32_1 === other.f32_1))
    return false;
  if (!equals_0(this.g32_1, other.g32_1))
    return false;
  return true;
};
function parseAndSortHeader(header) {
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = parseHeaderValue(header);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = parseAndSortHeader$lambda;
  var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
  return sortedWith(this_0, tmp$ret$0);
}
function HeaderValueParam_init_$Init$(name, value, $this) {
  HeaderValueParam.call($this, name, value, false);
  return $this;
}
function HeaderValueParam_init_$Create$(name, value) {
  return HeaderValueParam_init_$Init$(name, value, objectCreate(protoOf(HeaderValueParam)));
}
function HeaderValueParam(name, value, escapeValue) {
  this.b32_1 = name;
  this.c32_1 = value;
  this.d32_1 = escapeValue;
}
protoOf(HeaderValueParam).equals = function (other) {
  var tmp;
  var tmp_0;
  if (other instanceof HeaderValueParam) {
    tmp_0 = equals(other.b32_1, this.b32_1, true);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = equals(other.c32_1, this.c32_1, true);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(HeaderValueParam).hashCode = function () {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = this.b32_1.toLowerCase();
  var result = getStringHashCode(tmp$ret$1);
  var tmp = result;
  var tmp_0 = imul(31, result);
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = this.c32_1.toLowerCase();
  result = tmp + (tmp_0 + getStringHashCode(tmp$ret$3) | 0) | 0;
  return result;
};
protoOf(HeaderValueParam).wf = function () {
  return this.b32_1;
};
protoOf(HeaderValueParam).xf = function () {
  return this.c32_1;
};
protoOf(HeaderValueParam).toString = function () {
  return 'HeaderValueParam(name=' + this.b32_1 + ', value=' + this.c32_1 + ', escapeValue=' + this.d32_1 + ')';
};
function parseHeaderValue(text) {
  return parseHeaderValue_0(text, false);
}
function parseHeaderValue_0(text, parametersOnly) {
  if (text == null) {
    return emptyList();
  }
  var position = 0;
  var tmp = LazyThreadSafetyMode_NONE_getInstance();
  var items = lazy(tmp, parseHeaderValue$lambda);
  while (position <= get_lastIndex_0(text)) {
    position = parseHeaderValueItem(text, position, items, parametersOnly);
  }
  return valueOrEmpty(items);
}
function parseHeaderValueItem(text, start, items, parametersOnly) {
  var position = start;
  var tmp = LazyThreadSafetyMode_NONE_getInstance();
  var parameters = lazy(tmp, parseHeaderValueItem$lambda);
  var valueEnd = parametersOnly ? position : null;
  while (position <= get_lastIndex_0(text)) {
    var tmp0_subject = charCodeAt(text, position);
    if (tmp0_subject === _Char___init__impl__6a9atx(44)) {
      var tmp_0 = items.w();
      var tmp1_elvis_lhs = valueEnd;
      tmp_0.j(new HeaderValue(subtrim(text, start, tmp1_elvis_lhs == null ? position : tmp1_elvis_lhs), valueOrEmpty(parameters)));
      return position + 1 | 0;
    } else if (tmp0_subject === _Char___init__impl__6a9atx(59)) {
      if (valueEnd == null)
        valueEnd = position;
      position = parseHeaderValueParameter(text, position + 1 | 0, parameters);
    } else {
      var tmp_1;
      if (parametersOnly) {
        tmp_1 = parseHeaderValueParameter(text, position, parameters);
      } else {
        tmp_1 = position + 1 | 0;
      }
      position = tmp_1;
    }
  }
  var tmp_2 = items.w();
  var tmp2_elvis_lhs = valueEnd;
  tmp_2.j(new HeaderValue(subtrim(text, start, tmp2_elvis_lhs == null ? position : tmp2_elvis_lhs), valueOrEmpty(parameters)));
  return position;
}
function valueOrEmpty(_this__u8e3s4) {
  return _this__u8e3s4.bn() ? _this__u8e3s4.w() : emptyList();
}
function subtrim(_this__u8e3s4, start, end) {
  // Inline function 'kotlin.text.trim' call
  var this_0 = substring(_this__u8e3s4, start, end);
  return toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
}
function parseHeaderValueParameter(text, start, parameters) {
  var position = start;
  while (position <= get_lastIndex_0(text)) {
    var tmp0_subject = charCodeAt(text, position);
    if (tmp0_subject === _Char___init__impl__6a9atx(61)) {
      var _destruct__k2r9zo = parseHeaderValueParameterValue(text, position + 1 | 0);
      var paramEnd = _destruct__k2r9zo.wf();
      var paramValue = _destruct__k2r9zo.xf();
      parseHeaderValueParameter$addParam(parameters, text, start, position, paramValue);
      return paramEnd;
    } else if (tmp0_subject === _Char___init__impl__6a9atx(59) || tmp0_subject === _Char___init__impl__6a9atx(44)) {
      parseHeaderValueParameter$addParam(parameters, text, start, position, '');
      return position;
    } else {
      position = position + 1 | 0;
    }
  }
  parseHeaderValueParameter$addParam(parameters, text, start, position, '');
  return position;
}
function parseHeaderValueParameterValue(value, start) {
  if (value.length === start) {
    return to(start, '');
  }
  var position = start;
  if (charCodeAt(value, start) === _Char___init__impl__6a9atx(34)) {
    return parseHeaderValueParameterValueQuoted(value, position + 1 | 0);
  }
  while (position <= get_lastIndex_0(value)) {
    var tmp0_subject = charCodeAt(value, position);
    if (tmp0_subject === _Char___init__impl__6a9atx(59) || tmp0_subject === _Char___init__impl__6a9atx(44))
      return to(position, subtrim(value, start, position));
    else {
      position = position + 1 | 0;
    }
  }
  return to(position, subtrim(value, start, position));
}
function parseHeaderValueParameterValueQuoted(value, start) {
  var position = start;
  var builder = StringBuilder_init_$Create$();
  loop: while (position <= get_lastIndex_0(value)) {
    var currentChar = charCodeAt(value, position);
    if (currentChar === _Char___init__impl__6a9atx(34) && nextIsDelimiterOrEnd(value, position)) {
      return to(position + 1 | 0, builder.toString());
    } else if (currentChar === _Char___init__impl__6a9atx(92) && position < (get_lastIndex_0(value) - 2 | 0)) {
      builder.l7(charCodeAt(value, position + 1 | 0));
      position = position + 2 | 0;
      continue loop;
    }
    builder.l7(currentChar);
    position = position + 1 | 0;
  }
  var tmp = position;
  var tmp0 = _Char___init__impl__6a9atx(34);
  // Inline function 'kotlin.text.plus' call
  var other = builder.toString();
  var tmp$ret$0 = toString_0(tmp0) + other;
  return to(tmp, tmp$ret$0);
}
function nextIsDelimiterOrEnd(_this__u8e3s4, start) {
  var position = start + 1 | 0;
  loop: while (position < _this__u8e3s4.length && charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(32)) {
    position = position + 1 | 0;
  }
  return position === _this__u8e3s4.length || charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(59) || charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(44);
}
function sam$kotlin_Comparator$0(function_0) {
  this.l39_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).od = function (a, b) {
  return this.l39_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.od(a, b);
};
protoOf(sam$kotlin_Comparator$0).r2 = function () {
  return this.l39_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals_0(this.r2(), other.r2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.r2());
};
function parseHeaderValueParameter$addParam($parameters, text, start, end, value) {
  var name = subtrim(text, start, end);
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(name) === 0) {
    return Unit_instance;
  }
  $parameters.w().j(HeaderValueParam_init_$Create$(name, value));
}
function parseAndSortHeader$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.h32_1;
  var tmp$ret$1 = a.h32_1;
  return compareValues(tmp, tmp$ret$1);
}
function parseHeaderValue$lambda() {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList_init_$Create$_0();
}
function parseHeaderValueItem$lambda() {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList_init_$Create$_0();
}
function HttpHeaders() {
  HttpHeaders_instance = this;
  this.l35_1 = 'Accept';
  this.m35_1 = 'Accept-Charset';
  this.n35_1 = 'Accept-Encoding';
  this.o35_1 = 'Accept-Language';
  this.p35_1 = 'Accept-Ranges';
  this.q35_1 = 'Age';
  this.r35_1 = 'Allow';
  this.s35_1 = 'ALPN';
  this.t35_1 = 'Authentication-Info';
  this.u35_1 = 'Authorization';
  this.v35_1 = 'Cache-Control';
  this.w35_1 = 'Connection';
  this.x35_1 = 'Content-Disposition';
  this.y35_1 = 'Content-Encoding';
  this.z35_1 = 'Content-Language';
  this.a36_1 = 'Content-Length';
  this.b36_1 = 'Content-Location';
  this.c36_1 = 'Content-Range';
  this.d36_1 = 'Content-Type';
  this.e36_1 = 'Cookie';
  this.f36_1 = 'DASL';
  this.g36_1 = 'Date';
  this.h36_1 = 'DAV';
  this.i36_1 = 'Depth';
  this.j36_1 = 'Destination';
  this.k36_1 = 'ETag';
  this.l36_1 = 'Expect';
  this.m36_1 = 'Expires';
  this.n36_1 = 'From';
  this.o36_1 = 'Forwarded';
  this.p36_1 = 'Host';
  this.q36_1 = 'HTTP2-Settings';
  this.r36_1 = 'If';
  this.s36_1 = 'If-Match';
  this.t36_1 = 'If-Modified-Since';
  this.u36_1 = 'If-None-Match';
  this.v36_1 = 'If-Range';
  this.w36_1 = 'If-Schedule-Tag-Match';
  this.x36_1 = 'If-Unmodified-Since';
  this.y36_1 = 'Last-Modified';
  this.z36_1 = 'Location';
  this.a37_1 = 'Lock-Token';
  this.b37_1 = 'Link';
  this.c37_1 = 'Max-Forwards';
  this.d37_1 = 'MIME-Version';
  this.e37_1 = 'Ordering-Type';
  this.f37_1 = 'Origin';
  this.g37_1 = 'Overwrite';
  this.h37_1 = 'Position';
  this.i37_1 = 'Pragma';
  this.j37_1 = 'Prefer';
  this.k37_1 = 'Preference-Applied';
  this.l37_1 = 'Proxy-Authenticate';
  this.m37_1 = 'Proxy-Authentication-Info';
  this.n37_1 = 'Proxy-Authorization';
  this.o37_1 = 'Public-Key-Pins';
  this.p37_1 = 'Public-Key-Pins-Report-Only';
  this.q37_1 = 'Range';
  this.r37_1 = 'Referer';
  this.s37_1 = 'Retry-After';
  this.t37_1 = 'Schedule-Reply';
  this.u37_1 = 'Schedule-Tag';
  this.v37_1 = 'Sec-WebSocket-Accept';
  this.w37_1 = 'Sec-WebSocket-Extensions';
  this.x37_1 = 'Sec-WebSocket-Key';
  this.y37_1 = 'Sec-WebSocket-Protocol';
  this.z37_1 = 'Sec-WebSocket-Version';
  this.a38_1 = 'Server';
  this.b38_1 = 'Set-Cookie';
  this.c38_1 = 'SLUG';
  this.d38_1 = 'Strict-Transport-Security';
  this.e38_1 = 'TE';
  this.f38_1 = 'Timeout';
  this.g38_1 = 'Trailer';
  this.h38_1 = 'Transfer-Encoding';
  this.i38_1 = 'Upgrade';
  this.j38_1 = 'User-Agent';
  this.k38_1 = 'Vary';
  this.l38_1 = 'Via';
  this.m38_1 = 'Warning';
  this.n38_1 = 'WWW-Authenticate';
  this.o38_1 = 'Access-Control-Allow-Origin';
  this.p38_1 = 'Access-Control-Allow-Methods';
  this.q38_1 = 'Access-Control-Allow-Credentials';
  this.r38_1 = 'Access-Control-Allow-Headers';
  this.s38_1 = 'Access-Control-Request-Method';
  this.t38_1 = 'Access-Control-Request-Headers';
  this.u38_1 = 'Access-Control-Expose-Headers';
  this.v38_1 = 'Access-Control-Max-Age';
  this.w38_1 = 'X-Http-Method-Override';
  this.x38_1 = 'X-Forwarded-Host';
  this.y38_1 = 'X-Forwarded-Server';
  this.z38_1 = 'X-Forwarded-Proto';
  this.a39_1 = 'X-Forwarded-For';
  this.b39_1 = 'X-Forwarded-Port';
  this.c39_1 = 'X-Request-ID';
  this.d39_1 = 'X-Correlation-ID';
  this.e39_1 = 'X-Total-Count';
  this.f39_1 = 'Last-Event-ID';
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.g39_1 = [this.h38_1, this.i38_1];
  this.h39_1 = asList(this.g39_1);
}
protoOf(HttpHeaders).i39 = function (name) {
  // Inline function 'kotlin.text.forEachIndexed' call
  var index = 0;
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(name)) {
    var item = charSequenceGet(name, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter_0(item)) {
      throw new IllegalHeaderNameException(name, _unary__edvuaz);
    }
  }
};
protoOf(HttpHeaders).j39 = function (value) {
  // Inline function 'kotlin.text.forEachIndexed' call
  var index = 0;
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(value)) {
    var item = charSequenceGet(value, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
      throw new IllegalHeaderValueException(value, _unary__edvuaz);
    }
  }
};
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance == null)
    new HttpHeaders();
  return HttpHeaders_instance;
}
function UnsafeHeaderException(header) {
  IllegalArgumentException_init_$Init$('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly', this);
  captureStack(this, UnsafeHeaderException);
}
function isDelimiter_0(ch) {
  return contains('"(),/:;<=>?@[\\]{}', ch);
}
function IllegalHeaderNameException(headerName, position) {
  var tmp = "Header name '" + headerName + "' contains illegal character '" + toString_0(charCodeAt(headerName, position)) + "'";
  // Inline function 'kotlin.code' call
  var this_0 = charCodeAt(headerName, position);
  var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
  IllegalArgumentException_init_$Init$(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'), this);
  captureStack(this, IllegalHeaderNameException);
  this.m39_1 = headerName;
  this.n39_1 = position;
}
function IllegalHeaderValueException(headerValue, position) {
  var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString_0(charCodeAt(headerValue, position)) + "'";
  // Inline function 'kotlin.code' call
  var this_0 = charCodeAt(headerValue, position);
  var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
  IllegalArgumentException_init_$Init$(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'), this);
  captureStack(this, IllegalHeaderValueException);
  this.o39_1 = headerValue;
  this.p39_1 = position;
}
function contentType(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.q39().g1c(HttpHeaders_getInstance().d36_1);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Companion_getInstance_0().in(tmp0_safe_receiver);
  }
  return tmp;
}
function contentType_0(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.q39().g1c(HttpHeaders_getInstance().d36_1);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Companion_getInstance_0().in(tmp0_safe_receiver);
  }
  return tmp;
}
function contentLength(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.q39().g1c(HttpHeaders_getInstance().a36_1);
  return tmp0_safe_receiver == null ? null : toLongOrNull(tmp0_safe_receiver);
}
function charset_0(_this__u8e3s4) {
  var tmp0_safe_receiver = contentType_0(_this__u8e3s4);
  return tmp0_safe_receiver == null ? null : charset(tmp0_safe_receiver);
}
function contentType_1(_this__u8e3s4, type) {
  return _this__u8e3s4.q39().g2x(HttpHeaders_getInstance().d36_1, type.toString());
}
function setCookie(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.q39().d2x(HttpHeaders_getInstance().b38_1);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = tmp0_safe_receiver.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      var list = splitSetCookieHeader(element);
      addAll(destination, list);
    }
    tmp = destination;
  }
  var tmp1_safe_receiver = tmp;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var _iterator__ex2g4s_0 = tmp1_safe_receiver.l();
    while (_iterator__ex2g4s_0.m()) {
      var item = _iterator__ex2g4s_0.n();
      var tmp$ret$3 = parseServerSetCookieHeader(item);
      destination_0.j(tmp$ret$3);
    }
    tmp_0 = destination_0;
  }
  var tmp2_elvis_lhs = tmp_0;
  return tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
}
function splitSetCookieHeader(_this__u8e3s4) {
  var comma = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(44));
  if (comma === -1) {
    return listOf_0(_this__u8e3s4);
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var result = ArrayList_init_$Create$_0();
  var current = 0;
  var equals = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(61), comma);
  var semicolon = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(59), comma);
  while (current < _this__u8e3s4.length && comma > 0) {
    if (equals < comma) {
      equals = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(61), comma);
    }
    var nextComma = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(44), comma + 1 | 0);
    while (0 <= nextComma ? nextComma < equals : false) {
      comma = nextComma;
      nextComma = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(44), nextComma + 1 | 0);
    }
    if (semicolon < comma) {
      semicolon = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(59), comma);
    }
    if (equals < 0) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element = substring_0(_this__u8e3s4, current);
      result.j(element);
      return result;
    }
    if (semicolon === -1 || semicolon > equals) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = substring(_this__u8e3s4, current, comma);
      result.j(element_0);
      current = comma + 1 | 0;
    }
    comma = nextComma;
  }
  if (current < _this__u8e3s4.length) {
    // Inline function 'kotlin.collections.plusAssign' call
    var element_1 = substring_0(_this__u8e3s4, current);
    result.j(element_1);
  }
  return result;
}
function get_REQUESTS_WITHOUT_BODY() {
  _init_properties_HttpMethod_kt__cbus5z();
  return REQUESTS_WITHOUT_BODY;
}
var REQUESTS_WITHOUT_BODY;
function Companion_3() {
  Companion_instance_3 = this;
  this.r39_1 = new HttpMethod('GET');
  this.s39_1 = new HttpMethod('POST');
  this.t39_1 = new HttpMethod('PUT');
  this.u39_1 = new HttpMethod('PATCH');
  this.v39_1 = new HttpMethod('DELETE');
  this.w39_1 = new HttpMethod('HEAD');
  this.x39_1 = new HttpMethod('OPTIONS');
  this.y39_1 = listOf([this.r39_1, this.s39_1, this.t39_1, this.u39_1, this.v39_1, this.w39_1, this.x39_1]);
}
var Companion_instance_3;
function Companion_getInstance_4() {
  if (Companion_instance_3 == null)
    new Companion_3();
  return Companion_instance_3;
}
function HttpMethod(value) {
  Companion_getInstance_4();
  this.z39_1 = value;
}
protoOf(HttpMethod).toString = function () {
  return this.z39_1;
};
protoOf(HttpMethod).hashCode = function () {
  return getStringHashCode(this.z39_1);
};
protoOf(HttpMethod).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof HttpMethod))
    return false;
  if (!(this.z39_1 === other.z39_1))
    return false;
  return true;
};
function get_supportsRequestBody(_this__u8e3s4) {
  _init_properties_HttpMethod_kt__cbus5z();
  return !get_REQUESTS_WITHOUT_BODY().q1(_this__u8e3s4);
}
var properties_initialized_HttpMethod_kt_ogor3f;
function _init_properties_HttpMethod_kt__cbus5z() {
  if (!properties_initialized_HttpMethod_kt_ogor3f) {
    properties_initialized_HttpMethod_kt_ogor3f = true;
    REQUESTS_WITHOUT_BODY = setOf([Companion_getInstance_4().r39_1, Companion_getInstance_4().w39_1, Companion_getInstance_4().x39_1, new HttpMethod('TRACE')]);
  }
}
function Companion_4() {
  Companion_instance_4 = this;
  this.a3a_1 = new HttpProtocolVersion('HTTP', 3, 0);
  this.b3a_1 = new HttpProtocolVersion('HTTP', 2, 0);
  this.c3a_1 = new HttpProtocolVersion('HTTP', 1, 1);
  this.d3a_1 = new HttpProtocolVersion('HTTP', 1, 0);
  this.e3a_1 = new HttpProtocolVersion('SPDY', 3, 0);
  this.f3a_1 = new HttpProtocolVersion('QUIC', 1, 0);
}
var Companion_instance_4;
function Companion_getInstance_5() {
  if (Companion_instance_4 == null)
    new Companion_4();
  return Companion_instance_4;
}
function HttpProtocolVersion(name, major, minor) {
  Companion_getInstance_5();
  this.g3a_1 = name;
  this.h3a_1 = major;
  this.i3a_1 = minor;
}
protoOf(HttpProtocolVersion).toString = function () {
  return this.g3a_1 + '/' + this.h3a_1 + '.' + this.i3a_1;
};
protoOf(HttpProtocolVersion).hashCode = function () {
  var result = getStringHashCode(this.g3a_1);
  result = imul(result, 31) + this.h3a_1 | 0;
  result = imul(result, 31) + this.i3a_1 | 0;
  return result;
};
protoOf(HttpProtocolVersion).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof HttpProtocolVersion))
    return false;
  if (!(this.g3a_1 === other.g3a_1))
    return false;
  if (!(this.h3a_1 === other.h3a_1))
    return false;
  if (!(this.i3a_1 === other.i3a_1))
    return false;
  return true;
};
function Companion_5() {
  Companion_instance_5 = this;
  this.j3a_1 = new HttpStatusCode(100, 'Continue');
  this.k3a_1 = new HttpStatusCode(101, 'Switching Protocols');
  this.l3a_1 = new HttpStatusCode(102, 'Processing');
  this.m3a_1 = new HttpStatusCode(200, 'OK');
  this.n3a_1 = new HttpStatusCode(201, 'Created');
  this.o3a_1 = new HttpStatusCode(202, 'Accepted');
  this.p3a_1 = new HttpStatusCode(203, 'Non-Authoritative Information');
  this.q3a_1 = new HttpStatusCode(204, 'No Content');
  this.r3a_1 = new HttpStatusCode(205, 'Reset Content');
  this.s3a_1 = new HttpStatusCode(206, 'Partial Content');
  this.t3a_1 = new HttpStatusCode(207, 'Multi-Status');
  this.u3a_1 = new HttpStatusCode(300, 'Multiple Choices');
  this.v3a_1 = new HttpStatusCode(301, 'Moved Permanently');
  this.w3a_1 = new HttpStatusCode(302, 'Found');
  this.x3a_1 = new HttpStatusCode(303, 'See Other');
  this.y3a_1 = new HttpStatusCode(304, 'Not Modified');
  this.z3a_1 = new HttpStatusCode(305, 'Use Proxy');
  this.a3b_1 = new HttpStatusCode(306, 'Switch Proxy');
  this.b3b_1 = new HttpStatusCode(307, 'Temporary Redirect');
  this.c3b_1 = new HttpStatusCode(308, 'Permanent Redirect');
  this.d3b_1 = new HttpStatusCode(400, 'Bad Request');
  this.e3b_1 = new HttpStatusCode(401, 'Unauthorized');
  this.f3b_1 = new HttpStatusCode(402, 'Payment Required');
  this.g3b_1 = new HttpStatusCode(403, 'Forbidden');
  this.h3b_1 = new HttpStatusCode(404, 'Not Found');
  this.i3b_1 = new HttpStatusCode(405, 'Method Not Allowed');
  this.j3b_1 = new HttpStatusCode(406, 'Not Acceptable');
  this.k3b_1 = new HttpStatusCode(407, 'Proxy Authentication Required');
  this.l3b_1 = new HttpStatusCode(408, 'Request Timeout');
  this.m3b_1 = new HttpStatusCode(409, 'Conflict');
  this.n3b_1 = new HttpStatusCode(410, 'Gone');
  this.o3b_1 = new HttpStatusCode(411, 'Length Required');
  this.p3b_1 = new HttpStatusCode(412, 'Precondition Failed');
  this.q3b_1 = new HttpStatusCode(413, 'Payload Too Large');
  this.r3b_1 = new HttpStatusCode(414, 'Request-URI Too Long');
  this.s3b_1 = new HttpStatusCode(415, 'Unsupported Media Type');
  this.t3b_1 = new HttpStatusCode(416, 'Requested Range Not Satisfiable');
  this.u3b_1 = new HttpStatusCode(417, 'Expectation Failed');
  this.v3b_1 = new HttpStatusCode(422, 'Unprocessable Entity');
  this.w3b_1 = new HttpStatusCode(423, 'Locked');
  this.x3b_1 = new HttpStatusCode(424, 'Failed Dependency');
  this.y3b_1 = new HttpStatusCode(425, 'Too Early');
  this.z3b_1 = new HttpStatusCode(426, 'Upgrade Required');
  this.a3c_1 = new HttpStatusCode(429, 'Too Many Requests');
  this.b3c_1 = new HttpStatusCode(431, 'Request Header Fields Too Large');
  this.c3c_1 = new HttpStatusCode(500, 'Internal Server Error');
  this.d3c_1 = new HttpStatusCode(501, 'Not Implemented');
  this.e3c_1 = new HttpStatusCode(502, 'Bad Gateway');
  this.f3c_1 = new HttpStatusCode(503, 'Service Unavailable');
  this.g3c_1 = new HttpStatusCode(504, 'Gateway Timeout');
  this.h3c_1 = new HttpStatusCode(505, 'HTTP Version Not Supported');
  this.i3c_1 = new HttpStatusCode(506, 'Variant Also Negotiates');
  this.j3c_1 = new HttpStatusCode(507, 'Insufficient Storage');
  this.k3c_1 = allStatusCodes();
  var tmp = this;
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = this.k3c_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var tmp$ret$0 = element.m3c_1;
    destination.a2(tmp$ret$0, element);
  }
  tmp.l3c_1 = destination;
}
var Companion_instance_5;
function Companion_getInstance_6() {
  if (Companion_instance_5 == null)
    new Companion_5();
  return Companion_instance_5;
}
function HttpStatusCode(value, description) {
  Companion_getInstance_6();
  this.m3c_1 = value;
  this.n3c_1 = description;
}
protoOf(HttpStatusCode).toString = function () {
  return '' + this.m3c_1 + ' ' + this.n3c_1;
};
protoOf(HttpStatusCode).equals = function (other) {
  var tmp;
  if (other instanceof HttpStatusCode) {
    tmp = other.m3c_1 === this.m3c_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(HttpStatusCode).hashCode = function () {
  return this.m3c_1;
};
protoOf(HttpStatusCode).o3c = function (other) {
  return this.m3c_1 - other.m3c_1 | 0;
};
protoOf(HttpStatusCode).d = function (other) {
  return this.o3c(other instanceof HttpStatusCode ? other : THROW_CCE());
};
function allStatusCodes() {
  return listOf([Companion_getInstance_6().j3a_1, Companion_getInstance_6().k3a_1, Companion_getInstance_6().l3a_1, Companion_getInstance_6().m3a_1, Companion_getInstance_6().n3a_1, Companion_getInstance_6().o3a_1, Companion_getInstance_6().p3a_1, Companion_getInstance_6().q3a_1, Companion_getInstance_6().r3a_1, Companion_getInstance_6().s3a_1, Companion_getInstance_6().t3a_1, Companion_getInstance_6().u3a_1, Companion_getInstance_6().v3a_1, Companion_getInstance_6().w3a_1, Companion_getInstance_6().x3a_1, Companion_getInstance_6().y3a_1, Companion_getInstance_6().z3a_1, Companion_getInstance_6().a3b_1, Companion_getInstance_6().b3b_1, Companion_getInstance_6().c3b_1, Companion_getInstance_6().d3b_1, Companion_getInstance_6().e3b_1, Companion_getInstance_6().f3b_1, Companion_getInstance_6().g3b_1, Companion_getInstance_6().h3b_1, Companion_getInstance_6().i3b_1, Companion_getInstance_6().j3b_1, Companion_getInstance_6().k3b_1, Companion_getInstance_6().l3b_1, Companion_getInstance_6().m3b_1, Companion_getInstance_6().n3b_1, Companion_getInstance_6().o3b_1, Companion_getInstance_6().p3b_1, Companion_getInstance_6().q3b_1, Companion_getInstance_6().r3b_1, Companion_getInstance_6().s3b_1, Companion_getInstance_6().t3b_1, Companion_getInstance_6().u3b_1, Companion_getInstance_6().v3b_1, Companion_getInstance_6().w3b_1, Companion_getInstance_6().x3b_1, Companion_getInstance_6().y3b_1, Companion_getInstance_6().z3b_1, Companion_getInstance_6().a3c_1, Companion_getInstance_6().b3c_1, Companion_getInstance_6().c3c_1, Companion_getInstance_6().d3c_1, Companion_getInstance_6().e3c_1, Companion_getInstance_6().f3c_1, Companion_getInstance_6().g3c_1, Companion_getInstance_6().h3c_1, Companion_getInstance_6().i3c_1, Companion_getInstance_6().j3c_1]);
}
function get_IPv4address() {
  _init_properties_IpParser_kt__wb6gcm();
  return IPv4address;
}
var IPv4address;
function get_IPv6address() {
  _init_properties_IpParser_kt__wb6gcm();
  return IPv6address;
}
var IPv6address;
function get_IP_PARSER() {
  _init_properties_IpParser_kt__wb6gcm();
  return IP_PARSER;
}
var IP_PARSER;
function hostIsIp(host) {
  _init_properties_IpParser_kt__wb6gcm();
  return get_IP_PARSER().p3c(host);
}
var properties_initialized_IpParser_kt_4lpsd4;
function _init_properties_IpParser_kt__wb6gcm() {
  if (!properties_initialized_IpParser_kt_4lpsd4) {
    properties_initialized_IpParser_kt_4lpsd4 = true;
    IPv4address = then(then_0(then(then_0(then(then_0(get_digits(), '.'), get_digits()), '.'), get_digits()), '.'), get_digits());
    IPv6address = then_0(then_1('[', atLeastOne(or(get_hex(), ':'))), ']');
    IP_PARSER = buildRegexParser(or_0(get_IPv4address(), get_IPv6address()));
  }
}
function Companion_6() {
  Companion_instance_6 = this;
  this.q3c_1 = EmptyParameters_instance;
}
var Companion_instance_6;
function Companion_getInstance_7() {
  if (Companion_instance_6 == null)
    new Companion_6();
  return Companion_instance_6;
}
function Parameters() {
}
function EmptyParameters() {
}
protoOf(EmptyParameters).c2x = function () {
  return true;
};
protoOf(EmptyParameters).d2x = function (name) {
  return null;
};
protoOf(EmptyParameters).f2x = function () {
  return emptySet();
};
protoOf(EmptyParameters).x2w = function () {
  return emptySet();
};
protoOf(EmptyParameters).q = function () {
  return true;
};
protoOf(EmptyParameters).toString = function () {
  return 'Parameters ' + toString(this.x2w());
};
protoOf(EmptyParameters).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Parameters) : false) {
    tmp = other.q();
  } else {
    tmp = false;
  }
  return tmp;
};
var EmptyParameters_instance;
function EmptyParameters_getInstance() {
  return EmptyParameters_instance;
}
function ParametersBuilder(size) {
  size = size === VOID ? 8 : size;
  return new ParametersBuilderImpl(size);
}
function ParametersBuilderImpl(size) {
  size = size === VOID ? 8 : size;
  StringValuesBuilderImpl.call(this, true, size);
}
protoOf(ParametersBuilderImpl).z1m = function () {
  return new ParametersImpl(this.a2x_1);
};
function ParametersImpl(values) {
  values = values === VOID ? emptyMap() : values;
  StringValuesImpl.call(this, true, values);
}
protoOf(ParametersImpl).toString = function () {
  return 'Parameters ' + toString(this.x2w());
};
function parseQueryString(query, startIndex, limit, decode) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  limit = limit === VOID ? 1000 : limit;
  decode = decode === VOID ? true : decode;
  var tmp;
  if (startIndex > get_lastIndex_0(query)) {
    tmp = Companion_getInstance_7().q3c_1;
  } else {
    // Inline function 'io.ktor.http.Companion.build' call
    Companion_getInstance_7();
    // Inline function 'kotlin.apply' call
    var this_0 = ParametersBuilder();
    parse(this_0, query, startIndex, limit, decode);
    tmp = this_0.z1m();
  }
  return tmp;
}
function parse(_this__u8e3s4, query, startIndex, limit, decode) {
  var count = 0;
  var nameIndex = startIndex;
  var equalIndex = -1;
  var inductionVariable = startIndex;
  var last = get_lastIndex_0(query);
  if (inductionVariable <= last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (count === limit) {
        return Unit_instance;
      }
      var tmp0_subject = charCodeAt(query, index);
      if (tmp0_subject === _Char___init__impl__6a9atx(38)) {
        appendParam(_this__u8e3s4, query, nameIndex, equalIndex, index, decode);
        nameIndex = index + 1 | 0;
        equalIndex = -1;
        count = count + 1 | 0;
      } else if (tmp0_subject === _Char___init__impl__6a9atx(61)) {
        if (equalIndex === -1) {
          equalIndex = index;
        }
      }
    }
     while (!(index === last));
  if (count === limit) {
    return Unit_instance;
  }
  appendParam(_this__u8e3s4, query, nameIndex, equalIndex, query.length, decode);
}
function appendParam(_this__u8e3s4, query, nameIndex, equalIndex, endIndex, decode) {
  if (equalIndex === -1) {
    var spaceNameIndex = trimStart_0(nameIndex, endIndex, query);
    var spaceEndIndex = trimEnd_0(spaceNameIndex, endIndex, query);
    if (spaceEndIndex > spaceNameIndex) {
      var name = decode ? decodeURLQueryComponent(query, spaceNameIndex, spaceEndIndex) : substring(query, spaceNameIndex, spaceEndIndex);
      _this__u8e3s4.y2w(name, emptyList());
    }
    return Unit_instance;
  }
  var spaceNameIndex_0 = trimStart_0(nameIndex, equalIndex, query);
  var spaceEqualIndex = trimEnd_0(spaceNameIndex_0, equalIndex, query);
  if (spaceEqualIndex > spaceNameIndex_0) {
    var name_0 = decode ? decodeURLQueryComponent(query, spaceNameIndex_0, spaceEqualIndex) : substring(query, spaceNameIndex_0, spaceEqualIndex);
    var spaceValueIndex = trimStart_0(equalIndex + 1 | 0, endIndex, query);
    var spaceEndIndex_0 = trimEnd_0(spaceValueIndex, endIndex, query);
    var value = decode ? decodeURLQueryComponent(query, spaceValueIndex, spaceEndIndex_0, true) : substring(query, spaceValueIndex, spaceEndIndex_0);
    _this__u8e3s4.i2x(name_0, value);
  }
}
function trimStart_0(start, end, query) {
  var spaceIndex = start;
  while (spaceIndex < end && isWhitespace(charSequenceGet(query, spaceIndex))) {
    spaceIndex = spaceIndex + 1 | 0;
  }
  return spaceIndex;
}
function trimEnd_0(start, end, text) {
  var spaceIndex = end;
  while (spaceIndex > start && isWhitespace(charSequenceGet(text, spaceIndex - 1 | 0))) {
    spaceIndex = spaceIndex - 1 | 0;
  }
  return spaceIndex;
}
function applyOrigin($this) {
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = $this.t3c_1;
  if (charSequenceLength(this_0) > 0) {
    tmp = true;
  } else {
    tmp = $this.f3d().d3d_1 === 'file';
  }
  if (tmp)
    return Unit_instance;
  $this.t3c_1 = Companion_getInstance_8().z3d_1.g3d_1;
  if ($this.w3c_1 == null)
    $this.w3c_1 = Companion_getInstance_8().z3d_1.r3d_1;
  if ($this.v3c_1 === 0) {
    $this.b3e(Companion_getInstance_8().z3d_1.h3d_1);
  }
}
function Companion_7() {
  Companion_instance_7 = this;
  this.z3d_1 = Url(get_origin(this));
  this.a3e_1 = 256;
}
var Companion_instance_7;
function Companion_getInstance_8() {
  if (Companion_instance_7 == null)
    new Companion_7();
  return Companion_instance_7;
}
function URLBuilder(protocol, host, port, user, password, pathSegments, parameters, fragment, trailingQuery) {
  Companion_getInstance_8();
  protocol = protocol === VOID ? null : protocol;
  host = host === VOID ? '' : host;
  port = port === VOID ? 0 : port;
  user = user === VOID ? null : user;
  password = password === VOID ? null : password;
  pathSegments = pathSegments === VOID ? emptyList() : pathSegments;
  parameters = parameters === VOID ? Companion_getInstance_7().q3c_1 : parameters;
  fragment = fragment === VOID ? '' : fragment;
  trailingQuery = trailingQuery === VOID ? false : trailingQuery;
  this.t3c_1 = host;
  this.u3c_1 = trailingQuery;
  this.v3c_1 = port;
  this.w3c_1 = protocol;
  var tmp = this;
  tmp.x3c_1 = user == null ? null : encodeURLParameter(user);
  var tmp_0 = this;
  tmp_0.y3c_1 = password == null ? null : encodeURLParameter(password);
  this.z3c_1 = encodeURLQueryComponent(fragment);
  var tmp_1 = this;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(pathSegments, 10));
  var _iterator__ex2g4s = pathSegments.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var tmp$ret$0 = encodeURLPathPart(item);
    destination.j(tmp$ret$0);
  }
  tmp_1.a3d_1 = destination;
  this.b3d_1 = encodeParameters(parameters);
  this.c3d_1 = new UrlDecodedParametersBuilder(this.b3d_1);
}
protoOf(URLBuilder).b3e = function (value) {
  // Inline function 'kotlin.require' call
  if (!(0 <= value ? value <= 65535 : false)) {
    var message = 'Port must be between 0 and 65535, or 0 if not set. Provided: ' + value;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  this.v3c_1 = value;
};
protoOf(URLBuilder).c3e = function (value) {
  this.w3c_1 = value;
};
protoOf(URLBuilder).f3d = function () {
  var tmp0_elvis_lhs = this.w3c_1;
  return tmp0_elvis_lhs == null ? Companion_getInstance_9().d3e_1 : tmp0_elvis_lhs;
};
protoOf(URLBuilder).j3e = function (value) {
  var tmp = this;
  tmp.x3c_1 = value == null ? null : encodeURLParameter(value);
};
protoOf(URLBuilder).k3e = function () {
  var tmp0_safe_receiver = this.x3c_1;
  return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
};
protoOf(URLBuilder).l3e = function () {
  var tmp0_safe_receiver = this.y3c_1;
  return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
};
protoOf(URLBuilder).m3e = function () {
  return decodeURLQueryComponent(this.z3c_1);
};
protoOf(URLBuilder).n3e = function (value) {
  var tmp = this;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
  var _iterator__ex2g4s = value.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var tmp$ret$0 = encodeURLPathPart(item);
    destination.j(tmp$ret$0);
  }
  tmp.a3d_1 = destination;
};
protoOf(URLBuilder).o3e = function () {
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.a3d_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var tmp$ret$0 = decodeURLPart(item);
    destination.j(tmp$ret$0);
  }
  return destination;
};
protoOf(URLBuilder).p3e = function (value) {
  this.b3d_1 = value;
  this.c3d_1 = new UrlDecodedParametersBuilder(value);
};
protoOf(URLBuilder).q3e = function () {
  applyOrigin(this);
  return appendTo(this, StringBuilder_init_$Create$_0(256)).toString();
};
protoOf(URLBuilder).toString = function () {
  return appendTo(this, StringBuilder_init_$Create$_0(256)).toString();
};
protoOf(URLBuilder).z1m = function () {
  applyOrigin(this);
  return new Url_0(this.w3c_1, this.t3c_1, this.v3c_1, this.o3e(), this.c3d_1.z1m(), this.m3e(), this.k3e(), this.l3e(), this.u3c_1, this.q3e());
};
function get_authority(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.k7(get_encodedUserAndPassword(_this__u8e3s4));
  this_0.k7(_this__u8e3s4.t3c_1);
  if (!(_this__u8e3s4.v3c_1 === 0) && !(_this__u8e3s4.v3c_1 === _this__u8e3s4.f3d().e3d_1)) {
    this_0.k7(':');
    this_0.k7(_this__u8e3s4.v3c_1.toString());
  }
  return this_0.toString();
}
function appendTo(_this__u8e3s4, out) {
  out.k(_this__u8e3s4.f3d().d3d_1);
  switch (_this__u8e3s4.f3d().d3d_1) {
    case 'file':
      appendFile(out, _this__u8e3s4.t3c_1, get_encodedPath(_this__u8e3s4));
      return out;
    case 'mailto':
      appendMailto(out, get_encodedUserAndPassword(_this__u8e3s4), _this__u8e3s4.t3c_1);
      return out;
    case 'about':
      appendPayload(out, _this__u8e3s4.t3c_1);
      return out;
    case 'tel':
      appendPayload(out, _this__u8e3s4.t3c_1);
      return out;
    case 'data':
      appendPayload(out, _this__u8e3s4.t3c_1);
      return out;
  }
  out.k('://');
  out.k(get_authority(_this__u8e3s4));
  appendUrlFullPath(out, get_encodedPath(_this__u8e3s4), _this__u8e3s4.b3d_1, _this__u8e3s4.u3c_1);
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = _this__u8e3s4.z3c_1;
  if (charSequenceLength(this_0) > 0) {
    out.l7(_Char___init__impl__6a9atx(35));
    out.k(_this__u8e3s4.z3c_1);
  }
  return out;
}
function get_encodedUserAndPassword(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  appendUserAndPassword(this_0, _this__u8e3s4.x3c_1, _this__u8e3s4.y3c_1);
  return this_0.toString();
}
function appendFile(_this__u8e3s4, host, encodedPath) {
  _this__u8e3s4.k('://');
  _this__u8e3s4.k(host);
  if (!startsWith_1(encodedPath, _Char___init__impl__6a9atx(47))) {
    _this__u8e3s4.l7(_Char___init__impl__6a9atx(47));
  }
  _this__u8e3s4.k(encodedPath);
}
function set_encodedPath(_this__u8e3s4, value) {
  _this__u8e3s4.a3d_1 = isBlank(value) ? emptyList() : value === '/' ? get_ROOT_PATH() : toMutableList(split(value, charArrayOf([_Char___init__impl__6a9atx(47)])));
}
function get_encodedPath(_this__u8e3s4) {
  return joinPath(_this__u8e3s4.a3d_1);
}
function appendMailto(_this__u8e3s4, encodedUser, host) {
  _this__u8e3s4.k(':');
  _this__u8e3s4.k(encodedUser);
  _this__u8e3s4.k(host);
}
function appendPayload(_this__u8e3s4, host) {
  _this__u8e3s4.k(':');
  _this__u8e3s4.k(host);
}
function joinPath(_this__u8e3s4) {
  if (_this__u8e3s4.q())
    return '';
  if (_this__u8e3s4.o() === 1) {
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = first_0(_this__u8e3s4);
    if (charSequenceLength(this_0) === 0)
      return '/';
    return first_0(_this__u8e3s4);
  }
  return joinToString(_this__u8e3s4, '/');
}
function clone(_this__u8e3s4) {
  return takeFrom_0(new URLBuilder(), _this__u8e3s4);
}
function get_ROOT_PATH() {
  _init_properties_URLParser_kt__sf11to();
  return ROOT_PATH;
}
var ROOT_PATH;
function takeFrom(_this__u8e3s4, urlString) {
  _init_properties_URLParser_kt__sf11to();
  if (isBlank(urlString))
    return _this__u8e3s4;
  var tmp;
  try {
    tmp = takeFromUnsafe(_this__u8e3s4, urlString);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var cause = $p;
      throw new URLParserException(urlString, cause);
    } else {
      throw $p;
    }
  }
  return tmp;
}
function takeFromUnsafe(_this__u8e3s4, urlString) {
  _init_properties_URLParser_kt__sf11to();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.indexOfFirst' call
    var inductionVariable = 0;
    var last = charSequenceLength(urlString) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = charSequenceGet(urlString, index);
        if (!isWhitespace(it)) {
          tmp$ret$1 = index;
          break $l$block;
        }
      }
       while (inductionVariable <= last);
    tmp$ret$1 = -1;
  }
  var startIndex = tmp$ret$1;
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.text.indexOfLast' call
    var inductionVariable_0 = charSequenceLength(urlString) - 1 | 0;
    if (0 <= inductionVariable_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + -1 | 0;
        var it_0 = charSequenceGet(urlString, index_0);
        if (!isWhitespace(it_0)) {
          tmp$ret$3 = index_0;
          break $l$block_0;
        }
      }
       while (0 <= inductionVariable_0);
    tmp$ret$3 = -1;
  }
  var endIndex = tmp$ret$3 + 1 | 0;
  var schemeLength = findScheme(urlString, startIndex, endIndex);
  if (schemeLength > 0) {
    var scheme = substring(urlString, startIndex, startIndex + schemeLength | 0);
    _this__u8e3s4.c3e(Companion_getInstance_9().r3e(scheme));
    startIndex = startIndex + (schemeLength + 1 | 0) | 0;
  }
  if (_this__u8e3s4.f3d().d3d_1 === 'data') {
    _this__u8e3s4.t3c_1 = substring(urlString, startIndex, endIndex);
    return _this__u8e3s4;
  }
  var slashCount = count(urlString, startIndex, endIndex, _Char___init__impl__6a9atx(47));
  startIndex = startIndex + slashCount | 0;
  if (_this__u8e3s4.f3d().d3d_1 === 'file') {
    parseFile(_this__u8e3s4, urlString, startIndex, endIndex, slashCount);
    return _this__u8e3s4;
  }
  if (_this__u8e3s4.f3d().d3d_1 === 'mailto') {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(slashCount === 0)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    parseMailto(_this__u8e3s4, urlString, startIndex, endIndex);
    return _this__u8e3s4;
  }
  if (_this__u8e3s4.f3d().d3d_1 === 'about') {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(slashCount === 0)) {
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    _this__u8e3s4.t3c_1 = substring(urlString, startIndex, endIndex);
    return _this__u8e3s4;
  }
  if (_this__u8e3s4.f3d().d3d_1 === 'tel') {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(slashCount === 0)) {
      var message_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message_1));
    }
    _this__u8e3s4.t3c_1 = substring(urlString, startIndex, endIndex);
    return _this__u8e3s4;
  }
  if (slashCount >= 2) {
    loop: while (true) {
      // Inline function 'kotlin.takeIf' call
      var this_0 = indexOfAny(urlString, toCharArray('@/\\?#'), startIndex);
      var tmp;
      if (this_0 > 0) {
        tmp = this_0;
      } else {
        tmp = null;
      }
      var tmp0_elvis_lhs = tmp;
      var delimiter = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
      if (delimiter < endIndex && charCodeAt(urlString, delimiter) === _Char___init__impl__6a9atx(64)) {
        var passwordIndex = indexOfColonInHostPort(urlString, startIndex, delimiter);
        if (!(passwordIndex === -1)) {
          _this__u8e3s4.x3c_1 = substring(urlString, startIndex, passwordIndex);
          _this__u8e3s4.y3c_1 = substring(urlString, passwordIndex + 1 | 0, delimiter);
        } else {
          _this__u8e3s4.x3c_1 = substring(urlString, startIndex, delimiter);
        }
        startIndex = delimiter + 1 | 0;
      } else {
        fillHost(_this__u8e3s4, urlString, startIndex, delimiter);
        startIndex = delimiter;
        break loop;
      }
    }
  }
  if (startIndex >= endIndex) {
    _this__u8e3s4.a3d_1 = charCodeAt(urlString, endIndex - 1 | 0) === _Char___init__impl__6a9atx(47) ? get_ROOT_PATH() : emptyList();
    return _this__u8e3s4;
  }
  var tmp_0 = _this__u8e3s4;
  var tmp_1;
  if (slashCount === 0) {
    tmp_1 = dropLast(_this__u8e3s4.a3d_1, 1);
  } else {
    tmp_1 = emptyList();
  }
  tmp_0.a3d_1 = tmp_1;
  // Inline function 'kotlin.takeIf' call
  var this_1 = indexOfAny(urlString, toCharArray('?#'), startIndex);
  var tmp_2;
  if (this_1 > 0) {
    tmp_2 = this_1;
  } else {
    tmp_2 = null;
  }
  var tmp1_elvis_lhs = tmp_2;
  var pathEnd = tmp1_elvis_lhs == null ? endIndex : tmp1_elvis_lhs;
  if (pathEnd > startIndex) {
    var rawPath = substring(urlString, startIndex, pathEnd);
    var tmp_3;
    var tmp_4;
    if (_this__u8e3s4.a3d_1.o() === 1) {
      // Inline function 'kotlin.text.isEmpty' call
      var this_2 = first_0(_this__u8e3s4.a3d_1);
      tmp_4 = charSequenceLength(this_2) === 0;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = emptyList();
    } else {
      tmp_3 = _this__u8e3s4.a3d_1;
    }
    var basePath = tmp_3;
    var rawChunks = rawPath === '/' ? get_ROOT_PATH() : split(rawPath, charArrayOf([_Char___init__impl__6a9atx(47)]));
    var relativePath = plus_0(slashCount === 1 ? get_ROOT_PATH() : emptyList(), rawChunks);
    _this__u8e3s4.a3d_1 = plus_0(basePath, relativePath);
    startIndex = pathEnd;
  }
  if (startIndex < endIndex && charCodeAt(urlString, startIndex) === _Char___init__impl__6a9atx(63)) {
    startIndex = parseQuery(_this__u8e3s4, urlString, startIndex, endIndex);
  }
  parseFragment(_this__u8e3s4, urlString, startIndex, endIndex);
  return _this__u8e3s4;
}
function URLParserException(urlString, cause) {
  IllegalStateException_init_$Init$_0('Fail to parse url: ' + urlString, cause, this);
  captureStack(this, URLParserException);
}
function findScheme(urlString, startIndex, endIndex) {
  _init_properties_URLParser_kt__sf11to();
  var current = startIndex;
  var incorrectSchemePosition = -1;
  var firstChar = charCodeAt(urlString, current);
  if (!(_Char___init__impl__6a9atx(97) <= firstChar ? firstChar <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= firstChar ? firstChar <= _Char___init__impl__6a9atx(90) : false)) {
    incorrectSchemePosition = current;
  }
  while (current < endIndex) {
    var char = charCodeAt(urlString, current);
    if (char === _Char___init__impl__6a9atx(58)) {
      if (!(incorrectSchemePosition === -1)) {
        throw IllegalArgumentException_init_$Create$('Illegal character in scheme at position ' + incorrectSchemePosition);
      }
      return current - startIndex | 0;
    }
    if (char === _Char___init__impl__6a9atx(47) || char === _Char___init__impl__6a9atx(63) || char === _Char___init__impl__6a9atx(35))
      return -1;
    if (incorrectSchemePosition === -1 && !(_Char___init__impl__6a9atx(97) <= char ? char <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= char ? char <= _Char___init__impl__6a9atx(90) : false) && !(_Char___init__impl__6a9atx(48) <= char ? char <= _Char___init__impl__6a9atx(57) : false) && !(char === _Char___init__impl__6a9atx(46)) && !(char === _Char___init__impl__6a9atx(43)) && !(char === _Char___init__impl__6a9atx(45))) {
      incorrectSchemePosition = current;
    }
    current = current + 1 | 0;
  }
  return -1;
}
function count(urlString, startIndex, endIndex, char) {
  _init_properties_URLParser_kt__sf11to();
  var result = 0;
  $l$loop: while ((startIndex + result | 0) < endIndex && charCodeAt(urlString, startIndex + result | 0) === char) {
    result = result + 1 | 0;
  }
  return result;
}
function parseFile(_this__u8e3s4, urlString, startIndex, endIndex, slashCount) {
  _init_properties_URLParser_kt__sf11to();
  switch (slashCount) {
    case 1:
      _this__u8e3s4.t3c_1 = '';
      set_encodedPath(_this__u8e3s4, substring(urlString, startIndex, endIndex));
      break;
    case 2:
      var nextSlash = indexOf(urlString, _Char___init__impl__6a9atx(47), startIndex);
      if (nextSlash === -1 || nextSlash === endIndex) {
        _this__u8e3s4.t3c_1 = substring(urlString, startIndex, endIndex);
        return Unit_instance;
      }

      _this__u8e3s4.t3c_1 = substring(urlString, startIndex, nextSlash);
      set_encodedPath(_this__u8e3s4, substring(urlString, nextSlash, endIndex));
      break;
    case 3:
      _this__u8e3s4.t3c_1 = '';
      set_encodedPath(_this__u8e3s4, '/' + substring(urlString, startIndex, endIndex));
      break;
    default:
      throw IllegalArgumentException_init_$Create$('Invalid file url: ' + urlString);
  }
}
function parseMailto(_this__u8e3s4, urlString, startIndex, endIndex) {
  _init_properties_URLParser_kt__sf11to();
  var delimiter = indexOf_0(urlString, '@', startIndex);
  if (delimiter === -1) {
    throw IllegalArgumentException_init_$Create$('Invalid mailto url: ' + urlString + ", it should contain '@'.");
  }
  _this__u8e3s4.j3e(decodeURLPart(substring(urlString, startIndex, delimiter)));
  _this__u8e3s4.t3c_1 = substring(urlString, delimiter + 1 | 0, endIndex);
}
function indexOfColonInHostPort(_this__u8e3s4, startIndex, endIndex) {
  _init_properties_URLParser_kt__sf11to();
  var skip = false;
  var inductionVariable = startIndex;
  if (inductionVariable < endIndex)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_subject = charCodeAt(_this__u8e3s4, index);
      if (tmp0_subject === _Char___init__impl__6a9atx(91))
        skip = true;
      else if (tmp0_subject === _Char___init__impl__6a9atx(93))
        skip = false;
      else if (tmp0_subject === _Char___init__impl__6a9atx(58))
        if (!skip)
          return index;
    }
     while (inductionVariable < endIndex);
  return -1;
}
function fillHost(_this__u8e3s4, urlString, startIndex, endIndex) {
  _init_properties_URLParser_kt__sf11to();
  // Inline function 'kotlin.takeIf' call
  var this_0 = indexOfColonInHostPort(urlString, startIndex, endIndex);
  var tmp;
  if (this_0 > 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_elvis_lhs = tmp;
  var colonIndex = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
  _this__u8e3s4.t3c_1 = substring(urlString, startIndex, colonIndex);
  var tmp_0;
  if ((colonIndex + 1 | 0) < endIndex) {
    tmp_0 = toInt(substring(urlString, colonIndex + 1 | 0, endIndex));
  } else {
    tmp_0 = 0;
  }
  _this__u8e3s4.b3e(tmp_0);
}
function parseQuery(_this__u8e3s4, urlString, startIndex, endIndex) {
  _init_properties_URLParser_kt__sf11to();
  if ((startIndex + 1 | 0) === endIndex) {
    _this__u8e3s4.u3c_1 = true;
    return endIndex;
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = indexOf(urlString, _Char___init__impl__6a9atx(35), startIndex + 1 | 0);
  var tmp;
  if (this_0 > 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_elvis_lhs = tmp;
  var fragmentStart = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
  var rawParameters = parseQueryString(substring(urlString, startIndex + 1 | 0, fragmentStart), VOID, VOID, false);
  rawParameters.k2x(parseQuery$lambda(_this__u8e3s4));
  return fragmentStart;
}
function parseFragment(_this__u8e3s4, urlString, startIndex, endIndex) {
  _init_properties_URLParser_kt__sf11to();
  if (startIndex < endIndex && charCodeAt(urlString, startIndex) === _Char___init__impl__6a9atx(35)) {
    _this__u8e3s4.z3c_1 = substring(urlString, startIndex + 1 | 0, endIndex);
  }
}
function parseQuery$lambda($this_parseQuery) {
  return function (key, values) {
    $this_parseQuery.b3d_1.y2w(key, values);
    return Unit_instance;
  };
}
var properties_initialized_URLParser_kt_hd1g6a;
function _init_properties_URLParser_kt__sf11to() {
  if (!properties_initialized_URLParser_kt_hd1g6a) {
    properties_initialized_URLParser_kt_hd1g6a = true;
    ROOT_PATH = listOf_0('');
  }
}
function Companion_8() {
  Companion_instance_8 = this;
  this.d3e_1 = new URLProtocol('http', 80);
  this.e3e_1 = new URLProtocol('https', 443);
  this.f3e_1 = new URLProtocol('ws', 80);
  this.g3e_1 = new URLProtocol('wss', 443);
  this.h3e_1 = new URLProtocol('socks', 1080);
  var tmp = this;
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = listOf([this.d3e_1, this.e3e_1, this.f3e_1, this.g3e_1, this.h3e_1]);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var tmp$ret$0 = element.d3d_1;
    destination.a2(tmp$ret$0, element);
  }
  tmp.i3e_1 = destination;
}
protoOf(Companion_8).r3e = function (name) {
  // Inline function 'kotlin.let' call
  var it = toLowerCasePreservingASCIIRules(name);
  var tmp0_elvis_lhs = Companion_getInstance_9().i3e_1.h2(it);
  return tmp0_elvis_lhs == null ? new URLProtocol(it, 0) : tmp0_elvis_lhs;
};
var Companion_instance_8;
function Companion_getInstance_9() {
  if (Companion_instance_8 == null)
    new Companion_8();
  return Companion_instance_8;
}
function URLProtocol(name, defaultPort) {
  Companion_getInstance_9();
  this.d3d_1 = name;
  this.e3d_1 = defaultPort;
  var tmp0 = this.d3d_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.all' call
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(tmp0)) {
      var element = charSequenceGet(tmp0, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (!isLowerCase(element)) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$1) {
    var message = 'All characters should be lower case';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(URLProtocol).toString = function () {
  return 'URLProtocol(name=' + this.d3d_1 + ', defaultPort=' + this.e3d_1 + ')';
};
protoOf(URLProtocol).hashCode = function () {
  var result = getStringHashCode(this.d3d_1);
  result = imul(result, 31) + this.e3d_1 | 0;
  return result;
};
protoOf(URLProtocol).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof URLProtocol))
    return false;
  if (!(this.d3d_1 === other.d3d_1))
    return false;
  if (!(this.e3d_1 === other.e3d_1))
    return false;
  return true;
};
function isSecure(_this__u8e3s4) {
  return _this__u8e3s4.d3d_1 === 'https' || _this__u8e3s4.d3d_1 === 'wss';
}
function isWebsocket(_this__u8e3s4) {
  return _this__u8e3s4.d3d_1 === 'ws' || _this__u8e3s4.d3d_1 === 'wss';
}
function takeFrom_0(_this__u8e3s4, url) {
  _this__u8e3s4.w3c_1 = url.w3c_1;
  _this__u8e3s4.t3c_1 = url.t3c_1;
  _this__u8e3s4.b3e(url.v3c_1);
  _this__u8e3s4.a3d_1 = url.a3d_1;
  _this__u8e3s4.x3c_1 = url.x3c_1;
  _this__u8e3s4.y3c_1 = url.y3c_1;
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAll(this_0, url.b3d_1);
  _this__u8e3s4.p3e(this_0);
  _this__u8e3s4.z3c_1 = url.z3c_1;
  _this__u8e3s4.u3c_1 = url.u3c_1;
  return _this__u8e3s4;
}
function Url(urlString) {
  return URLBuilder_0(urlString).z1m();
}
function appendUrlFullPath(_this__u8e3s4, encodedPath, encodedQueryParameters, trailingQuery) {
  var tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  if (!isBlank(encodedPath)) {
    tmp = !startsWith_0(encodedPath, '/');
  } else {
    tmp = false;
  }
  if (tmp) {
    _this__u8e3s4.l7(_Char___init__impl__6a9atx(47));
  }
  _this__u8e3s4.k(encodedPath);
  if (!encodedQueryParameters.q() || trailingQuery) {
    _this__u8e3s4.k('?');
  }
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = encodedQueryParameters.x2w();
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    // Inline function 'kotlin.collections.component1' call
    var key = element.v();
    // Inline function 'kotlin.collections.component2' call
    var value = element.w();
    var tmp_0;
    if (value.q()) {
      tmp_0 = listOf_0(to(key, null));
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
      var _iterator__ex2g4s_0 = value.l();
      while (_iterator__ex2g4s_0.m()) {
        var item = _iterator__ex2g4s_0.n();
        var tmp$ret$3 = to(key, item);
        destination_0.j(tmp$ret$3);
      }
      tmp_0 = destination_0;
    }
    var list = tmp_0;
    addAll(destination, list);
  }
  var tmp_1 = destination;
  joinTo(tmp_1, _this__u8e3s4, '&', VOID, VOID, VOID, VOID, appendUrlFullPath$lambda);
}
function appendUserAndPassword(_this__u8e3s4, encodedUser, encodedPassword) {
  if (encodedUser == null) {
    return Unit_instance;
  }
  _this__u8e3s4.k7(encodedUser);
  if (!(encodedPassword == null)) {
    _this__u8e3s4.l7(_Char___init__impl__6a9atx(58));
    _this__u8e3s4.k7(encodedPassword);
  }
  _this__u8e3s4.k7('@');
}
function URLBuilder_0(urlString) {
  return takeFrom(new URLBuilder(), urlString);
}
function get_hostWithPortIfSpecified(_this__u8e3s4) {
  var tmp0_subject = _this__u8e3s4.h3d_1;
  return tmp0_subject === 0 || tmp0_subject === _this__u8e3s4.s3d_1.e3d_1 ? _this__u8e3s4.g3d_1 : get_hostWithPort(_this__u8e3s4);
}
function get_hostWithPort(_this__u8e3s4) {
  return _this__u8e3s4.g3d_1 + ':' + _this__u8e3s4.s3e();
}
function URLBuilder_1(url) {
  return takeFrom_1(new URLBuilder(), url);
}
function takeFrom_1(_this__u8e3s4, url) {
  _this__u8e3s4.w3c_1 = url.r3d_1;
  _this__u8e3s4.t3c_1 = url.g3d_1;
  _this__u8e3s4.b3e(url.s3e());
  set_encodedPath(_this__u8e3s4, url.t3e());
  _this__u8e3s4.x3c_1 = url.u3e();
  _this__u8e3s4.y3c_1 = url.v3e();
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  this_0.j2x(parseQueryString(url.w3e(), VOID, VOID, false));
  _this__u8e3s4.p3e(this_0);
  _this__u8e3s4.z3c_1 = url.x3e();
  _this__u8e3s4.u3c_1 = url.m3d_1;
  return _this__u8e3s4;
}
function get_fullPath(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  appendUrlFullPath_0(this_0, _this__u8e3s4.t3e(), _this__u8e3s4.w3e(), _this__u8e3s4.m3d_1);
  return this_0.toString();
}
function appendUrlFullPath_0(_this__u8e3s4, encodedPath, encodedQuery, trailingQuery) {
  var tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  if (!isBlank(encodedPath)) {
    tmp = !startsWith_0(encodedPath, '/');
  } else {
    tmp = false;
  }
  if (tmp) {
    _this__u8e3s4.l7(_Char___init__impl__6a9atx(47));
  }
  _this__u8e3s4.k(encodedPath);
  var tmp_0;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(encodedQuery) > 0) {
    tmp_0 = true;
  } else {
    tmp_0 = trailingQuery;
  }
  if (tmp_0) {
    _this__u8e3s4.k('?');
  }
  _this__u8e3s4.k(encodedQuery);
}
function appendUrlFullPath$lambda(it) {
  var key = it.uf_1;
  var tmp;
  if (it.vf_1 == null) {
    tmp = key;
  } else {
    var value = toString_1(it.vf_1);
    tmp = key + '=' + value;
  }
  return tmp;
}
function Companion_9() {
}
var Companion_instance_9;
function Companion_getInstance_10() {
  return Companion_instance_9;
}
function Url$segments$delegate$lambda($pathSegments) {
  return function () {
    var tmp;
    if ($pathSegments.q()) {
      return emptyList();
    }
    var tmp_0;
    var tmp_1;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = first_0($pathSegments);
    if (charSequenceLength(this_0) === 0) {
      tmp_1 = $pathSegments.o() > 1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = 1;
    } else {
      tmp_0 = 0;
    }
    var start = tmp_0;
    var tmp_2;
    // Inline function 'kotlin.text.isEmpty' call
    var this_1 = last($pathSegments);
    if (charSequenceLength(this_1) === 0) {
      tmp_2 = get_lastIndex($pathSegments);
    } else {
      tmp_2 = get_lastIndex($pathSegments) + 1 | 0;
    }
    var end = tmp_2;
    return $pathSegments.v1(start, end);
  };
}
function Url$encodedPath$delegate$lambda($pathSegments, this$0) {
  return function () {
    var tmp;
    if ($pathSegments.q()) {
      return '';
    }
    var pathStartIndex = indexOf(this$0.n3d_1, _Char___init__impl__6a9atx(47), this$0.s3d_1.d3d_1.length + 3 | 0);
    var tmp_0;
    if (pathStartIndex === -1) {
      return '';
    }
    // Inline function 'kotlin.charArrayOf' call
    var tmp$ret$0 = charArrayOf([_Char___init__impl__6a9atx(63), _Char___init__impl__6a9atx(35)]);
    var pathEndIndex = indexOfAny(this$0.n3d_1, tmp$ret$0, pathStartIndex);
    var tmp_1;
    if (pathEndIndex === -1) {
      return substring_0(this$0.n3d_1, pathStartIndex);
    }
    return substring(this$0.n3d_1, pathStartIndex, pathEndIndex);
  };
}
function Url$_get_encodedPath_$ref_fg9j48() {
  return function (p0) {
    return p0.t3e();
  };
}
function Url$encodedQuery$delegate$lambda(this$0) {
  return function () {
    var queryStart = indexOf(this$0.n3d_1, _Char___init__impl__6a9atx(63)) + 1 | 0;
    var tmp;
    if (queryStart === 0) {
      return '';
    }
    var queryEnd = indexOf(this$0.n3d_1, _Char___init__impl__6a9atx(35), queryStart);
    var tmp_0;
    if (queryEnd === -1) {
      return substring_0(this$0.n3d_1, queryStart);
    }
    return substring(this$0.n3d_1, queryStart, queryEnd);
  };
}
function Url$_get_encodedQuery_$ref_c7vq1h() {
  return function (p0) {
    return p0.w3e();
  };
}
function Url$encodedPathAndQuery$delegate$lambda(this$0) {
  return function () {
    var pathStart = indexOf(this$0.n3d_1, _Char___init__impl__6a9atx(47), this$0.s3d_1.d3d_1.length + 3 | 0);
    var tmp;
    if (pathStart === -1) {
      return '';
    }
    var queryEnd = indexOf(this$0.n3d_1, _Char___init__impl__6a9atx(35), pathStart);
    var tmp_0;
    if (queryEnd === -1) {
      return substring_0(this$0.n3d_1, pathStart);
    }
    return substring(this$0.n3d_1, pathStart, queryEnd);
  };
}
function Url$encodedUser$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.k3d_1 == null) {
      return null;
    }
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this$0.k3d_1;
    if (charSequenceLength(this_0) === 0) {
      return '';
    }
    var usernameStart = this$0.s3d_1.d3d_1.length + 3 | 0;
    // Inline function 'kotlin.charArrayOf' call
    var tmp$ret$1 = charArrayOf([_Char___init__impl__6a9atx(58), _Char___init__impl__6a9atx(64)]);
    var usernameEnd = indexOfAny(this$0.n3d_1, tmp$ret$1, usernameStart);
    return substring(this$0.n3d_1, usernameStart, usernameEnd);
  };
}
function Url$_get_encodedUser_$ref_3lb9bi() {
  return function (p0) {
    return p0.u3e();
  };
}
function Url$encodedPassword$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.l3d_1 == null) {
      return null;
    }
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this$0.l3d_1;
    if (charSequenceLength(this_0) === 0) {
      return '';
    }
    var passwordStart = indexOf(this$0.n3d_1, _Char___init__impl__6a9atx(58), this$0.s3d_1.d3d_1.length + 3 | 0) + 1 | 0;
    var passwordEnd = indexOf(this$0.n3d_1, _Char___init__impl__6a9atx(64));
    return substring(this$0.n3d_1, passwordStart, passwordEnd);
  };
}
function Url$_get_encodedPassword_$ref_25ixc2() {
  return function (p0) {
    return p0.v3e();
  };
}
function Url$encodedFragment$delegate$lambda(this$0) {
  return function () {
    var fragmentStart = indexOf(this$0.n3d_1, _Char___init__impl__6a9atx(35)) + 1 | 0;
    var tmp;
    if (fragmentStart === 0) {
      return '';
    }
    return substring_0(this$0.n3d_1, fragmentStart);
  };
}
function Url$_get_encodedFragment_$ref_itp7pv() {
  return function (p0) {
    return p0.x3e();
  };
}
function Url_0(protocol, host, specifiedPort, pathSegments, parameters, fragment, user, password, trailingQuery, urlString) {
  this.g3d_1 = host;
  this.h3d_1 = specifiedPort;
  this.i3d_1 = parameters;
  this.j3d_1 = fragment;
  this.k3d_1 = user;
  this.l3d_1 = password;
  this.m3d_1 = trailingQuery;
  this.n3d_1 = urlString;
  var containsArg = this.h3d_1;
  // Inline function 'kotlin.require' call
  if (!(0 <= containsArg ? containsArg <= 65535 : false)) {
    var message = 'Port must be between 0 and 65535, or 0 if not set. Provided: ' + this.h3d_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  this.o3d_1 = pathSegments;
  this.p3d_1 = pathSegments;
  var tmp = this;
  tmp.q3d_1 = lazy_0(Url$segments$delegate$lambda(pathSegments));
  this.r3d_1 = protocol;
  var tmp_0 = this;
  var tmp0_elvis_lhs = this.r3d_1;
  tmp_0.s3d_1 = tmp0_elvis_lhs == null ? Companion_getInstance_9().d3e_1 : tmp0_elvis_lhs;
  var tmp_1 = this;
  tmp_1.t3d_1 = lazy_0(Url$encodedPath$delegate$lambda(pathSegments, this));
  var tmp_2 = this;
  tmp_2.u3d_1 = lazy_0(Url$encodedQuery$delegate$lambda(this));
  var tmp_3 = this;
  tmp_3.v3d_1 = lazy_0(Url$encodedPathAndQuery$delegate$lambda(this));
  var tmp_4 = this;
  tmp_4.w3d_1 = lazy_0(Url$encodedUser$delegate$lambda(this));
  var tmp_5 = this;
  tmp_5.x3d_1 = lazy_0(Url$encodedPassword$delegate$lambda(this));
  var tmp_6 = this;
  tmp_6.y3d_1 = lazy_0(Url$encodedFragment$delegate$lambda(this));
}
protoOf(Url_0).s3e = function () {
  // Inline function 'kotlin.takeUnless' call
  var this_0 = this.h3d_1;
  var tmp;
  if (!(this_0 === 0)) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? this.s3d_1.e3d_1 : tmp0_elvis_lhs;
};
protoOf(Url_0).t3e = function () {
  var tmp0 = this.t3d_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('encodedPath', 1, tmp, Url$_get_encodedPath_$ref_fg9j48(), null);
  return tmp0.w();
};
protoOf(Url_0).w3e = function () {
  var tmp0 = this.u3d_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('encodedQuery', 1, tmp, Url$_get_encodedQuery_$ref_c7vq1h(), null);
  return tmp0.w();
};
protoOf(Url_0).u3e = function () {
  var tmp0 = this.w3d_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('encodedUser', 1, tmp, Url$_get_encodedUser_$ref_3lb9bi(), null);
  return tmp0.w();
};
protoOf(Url_0).v3e = function () {
  var tmp0 = this.x3d_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('encodedPassword', 1, tmp, Url$_get_encodedPassword_$ref_25ixc2(), null);
  return tmp0.w();
};
protoOf(Url_0).x3e = function () {
  var tmp0 = this.y3d_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('encodedFragment', 1, tmp, Url$_get_encodedFragment_$ref_itp7pv(), null);
  return tmp0.w();
};
protoOf(Url_0).toString = function () {
  return this.n3d_1;
};
protoOf(Url_0).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof Url_0))
    THROW_CCE();
  return this.n3d_1 === other.n3d_1;
};
protoOf(Url_0).hashCode = function () {
  return getStringHashCode(this.n3d_1);
};
function get_authority_0(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.k7(get_encodedUserAndPassword_0(_this__u8e3s4));
  this_0.k7(get_hostWithPortIfSpecified(_this__u8e3s4));
  return this_0.toString();
}
function UrlSerializer() {
  UrlSerializer_instance = this;
  this.y3e_1 = PrimitiveSerialDescriptor('io.ktor.http.Url', STRING_getInstance());
}
protoOf(UrlSerializer).fp = function () {
  return this.y3e_1;
};
protoOf(UrlSerializer).hp = function (decoder) {
  return Url(decoder.ns());
};
protoOf(UrlSerializer).z3e = function (encoder, value) {
  encoder.wt(value.toString());
};
protoOf(UrlSerializer).gp = function (encoder, value) {
  return this.z3e(encoder, value instanceof Url_0 ? value : THROW_CCE());
};
var UrlSerializer_instance;
function UrlSerializer_getInstance() {
  if (UrlSerializer_instance == null)
    new UrlSerializer();
  return UrlSerializer_instance;
}
function get_encodedUserAndPassword_0(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  appendUserAndPassword(this_0, _this__u8e3s4.u3e(), _this__u8e3s4.v3e());
  return this_0.toString();
}
function UrlDecodedParametersBuilder(encodedParametersBuilder) {
  this.a3f_1 = encodedParametersBuilder;
  this.b3f_1 = this.a3f_1.c2x();
}
protoOf(UrlDecodedParametersBuilder).z1m = function () {
  return decodeParameters(this.a3f_1);
};
protoOf(UrlDecodedParametersBuilder).c2x = function () {
  return this.b3f_1;
};
protoOf(UrlDecodedParametersBuilder).d2x = function (name) {
  var tmp0_safe_receiver = this.a3f_1.d2x(encodeURLParameter(name));
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver, 10));
    var _iterator__ex2g4s = tmp0_safe_receiver.l();
    while (_iterator__ex2g4s.m()) {
      var item = _iterator__ex2g4s.n();
      var tmp$ret$0 = decodeURLQueryComponent(item, VOID, VOID, true);
      destination.j(tmp$ret$0);
    }
    tmp = destination;
  }
  return tmp;
};
protoOf(UrlDecodedParametersBuilder).e2x = function (name) {
  return this.a3f_1.e2x(encodeURLParameter(name));
};
protoOf(UrlDecodedParametersBuilder).f2x = function () {
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.a3f_1.f2x();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var tmp$ret$0 = decodeURLQueryComponent(item);
    destination.j(tmp$ret$0);
  }
  return toSet(destination);
};
protoOf(UrlDecodedParametersBuilder).q = function () {
  return this.a3f_1.q();
};
protoOf(UrlDecodedParametersBuilder).x2w = function () {
  return decodeParameters(this.a3f_1).x2w();
};
protoOf(UrlDecodedParametersBuilder).i2x = function (name, value) {
  return this.a3f_1.i2x(encodeURLParameter(name), encodeURLParameterValue(value));
};
protoOf(UrlDecodedParametersBuilder).j2x = function (stringValues) {
  return appendAllEncoded(this.a3f_1, stringValues);
};
protoOf(UrlDecodedParametersBuilder).y2w = function (name, values) {
  var tmp = encodeURLParameter(name);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(values, 10));
  var _iterator__ex2g4s = values.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var tmp$ret$0 = encodeURLParameterValue(item);
    destination.j(tmp$ret$0);
  }
  return this.a3f_1.y2w(tmp, destination);
};
protoOf(UrlDecodedParametersBuilder).w1 = function () {
  return this.a3f_1.w1();
};
function encodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllEncoded(this_0, parameters);
  return this_0;
}
function decodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllDecoded(this_0, parameters);
  return this_0.z1m();
}
function appendAllEncoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.f2x().l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var tmp0_elvis_lhs = parameters.d2x(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = encodeURLParameter(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.l();
    while (_iterator__ex2g4s_0.m()) {
      var item = _iterator__ex2g4s_0.n();
      var tmp$ret$0 = encodeURLParameterValue(item);
      destination.j(tmp$ret$0);
    }
    _this__u8e3s4.y2w(tmp, destination);
  }
}
function appendAllDecoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.f2x().l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var tmp0_elvis_lhs = parameters.d2x(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = decodeURLQueryComponent(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.l();
    while (_iterator__ex2g4s_0.m()) {
      var item = _iterator__ex2g4s_0.n();
      var tmp$ret$0 = decodeURLQueryComponent(item, VOID, VOID, true);
      destination.j(tmp$ret$0);
    }
    _this__u8e3s4.y2w(tmp, destination);
  }
}
function ByteArrayContent(bytes, contentType, status) {
  contentType = contentType === VOID ? null : contentType;
  status = status === VOID ? null : status;
  ByteArrayContent_0.call(this);
  this.d3f_1 = bytes;
  this.e3f_1 = contentType;
  this.f3f_1 = status;
}
protoOf(ByteArrayContent).g3f = function () {
  return this.e3f_1;
};
protoOf(ByteArrayContent).h3f = function () {
  return fromInt(this.d3f_1.length);
};
protoOf(ByteArrayContent).i3f = function () {
  return this.d3f_1;
};
function MultiPartData() {
}
function NoContent() {
  OutgoingContent.call(this);
}
function ReadChannelContent() {
  OutgoingContent.call(this);
}
function WriteChannelContent() {
}
function ByteArrayContent_0() {
  OutgoingContent.call(this);
}
function ProtocolUpgrade() {
}
function ContentWrapper() {
}
protoOf(ContentWrapper).r3f = function () {
  return this.q3f_1;
};
function OutgoingContent() {
  this.j3f_1 = null;
}
protoOf(OutgoingContent).g3f = function () {
  return null;
};
protoOf(OutgoingContent).h3f = function () {
  return null;
};
protoOf(OutgoingContent).q39 = function () {
  return Companion_getInstance_3().k39_1;
};
function NullBody() {
}
var NullBody_instance;
function NullBody_getInstance() {
  return NullBody_instance;
}
function isEmpty(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof NoContent) {
    tmp = true;
  } else {
    if (_this__u8e3s4 instanceof ContentWrapper) {
      tmp = isEmpty(_this__u8e3s4.r3f());
    } else {
      tmp = false;
    }
  }
  return tmp;
}
function TextContent(text, contentType, status) {
  status = status === VOID ? null : status;
  ByteArrayContent_0.call(this);
  this.t3f_1 = text;
  this.u3f_1 = contentType;
  this.v3f_1 = status;
  var tmp = this;
  var tmp0_elvis_lhs = charset(this.u3f_1);
  tmp.w3f_1 = toByteArray(this.t3f_1, tmp0_elvis_lhs == null ? Charsets_getInstance().g2u_1 : tmp0_elvis_lhs);
}
protoOf(TextContent).g3f = function () {
  return this.u3f_1;
};
protoOf(TextContent).h3f = function () {
  return fromInt(this.w3f_1.length);
};
protoOf(TextContent).i3f = function () {
  return this.w3f_1;
};
protoOf(TextContent).toString = function () {
  return 'TextContent[' + this.u3f_1.toString() + '] "' + take(this.t3f_1, 30) + '"';
};
function Grammar() {
}
function then(_this__u8e3s4, grammar) {
  return new SequenceGrammar(listOf([_this__u8e3s4, grammar]));
}
function then_0(_this__u8e3s4, value) {
  return then(_this__u8e3s4, new StringGrammar(value));
}
function then_1(_this__u8e3s4, grammar) {
  return then(new StringGrammar(_this__u8e3s4), grammar);
}
function atLeastOne(grammar) {
  return new AtLeastOne(grammar);
}
function or(_this__u8e3s4, value) {
  return or_0(_this__u8e3s4, new StringGrammar(value));
}
function or_0(_this__u8e3s4, grammar) {
  return new OrGrammar(listOf([_this__u8e3s4, grammar]));
}
function SequenceGrammar(sourceGrammars) {
  Grammar.call(this);
  var tmp = this;
  // Inline function 'io.ktor.http.parsing.flatten' call
  // Inline function 'kotlin.collections.mutableListOf' call
  var result = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = sourceGrammars.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    if (element instanceof SequenceGrammar) {
      // Inline function 'kotlin.collections.plusAssign' call
      var elements = element.x3f();
      addAll(result, elements);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      result.j(element);
    }
  }
  tmp.y3f_1 = result;
}
protoOf(SequenceGrammar).x3f = function () {
  return this.y3f_1;
};
function StringGrammar(value) {
  Grammar.call(this);
  this.z3f_1 = value;
}
function AtLeastOne(grammar) {
  Grammar.call(this);
  this.a3g_1 = grammar;
}
protoOf(AtLeastOne).b3g = function () {
  return this.a3g_1;
};
function OrGrammar(sourceGrammars) {
  Grammar.call(this);
  var tmp = this;
  // Inline function 'io.ktor.http.parsing.flatten' call
  // Inline function 'kotlin.collections.mutableListOf' call
  var result = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = sourceGrammars.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    if (element instanceof OrGrammar) {
      // Inline function 'kotlin.collections.plusAssign' call
      var elements = element.x3f();
      addAll(result, elements);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      result.j(element);
    }
  }
  tmp.c3g_1 = result;
}
protoOf(OrGrammar).x3f = function () {
  return this.c3g_1;
};
function ComplexGrammar() {
}
function SimpleGrammar() {
}
function RawGrammar(value) {
  Grammar.call(this);
  this.d3g_1 = value;
}
function to_0(_this__u8e3s4, other) {
  return new RangeGrammar(_this__u8e3s4, other);
}
function NamedGrammar() {
}
function MaybeGrammar() {
}
function ManyGrammar() {
}
function AnyOfGrammar() {
}
function RangeGrammar(from, to) {
  Grammar.call(this);
  this.e3g_1 = from;
  this.f3g_1 = to;
}
function get_digits() {
  return atLeastOne(get_digit());
}
function get_hex() {
  return or_0(or_0(get_digit(), to_0(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(70))), to_0(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(102)));
}
function get_digit() {
  return new RawGrammar('\\d');
}
function RegexParser(expression, indexes) {
  this.g3g_1 = expression;
  this.h3g_1 = indexes;
}
protoOf(RegexParser).p3c = function (input) {
  return this.g3g_1.rc(input);
};
function buildRegexParser(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var groups = LinkedHashMap_init_$Create$_0();
  var expression = toRegex(_this__u8e3s4, groups).i3g_1;
  return new RegexParser(Regex_init_$Create$(expression), groups);
}
function GrammarRegex(regexRaw, groupsCountRaw, group) {
  groupsCountRaw = groupsCountRaw === VOID ? 0 : groupsCountRaw;
  group = group === VOID ? false : group;
  this.i3g_1 = group ? '(' + regexRaw + ')' : regexRaw;
  this.j3g_1 = group ? groupsCountRaw + 1 | 0 : groupsCountRaw;
}
function toRegex(_this__u8e3s4, groups, offset, shouldGroup) {
  offset = offset === VOID ? 1 : offset;
  shouldGroup = shouldGroup === VOID ? false : shouldGroup;
  var tmp;
  if (_this__u8e3s4 instanceof StringGrammar) {
    tmp = new GrammarRegex(Companion_getInstance().jc(_this__u8e3s4.z3f_1));
  } else {
    if (_this__u8e3s4 instanceof RawGrammar) {
      tmp = new GrammarRegex(_this__u8e3s4.d3g_1);
    } else {
      if (_this__u8e3s4 instanceof NamedGrammar) {
        var nested = toRegex(_this__u8e3s4.m3g_1, groups, offset + 1 | 0);
        add(groups, _this__u8e3s4.l3g_1, offset);
        tmp = new GrammarRegex(nested.i3g_1, nested.j3g_1, true);
      } else {
        if (isInterface(_this__u8e3s4, ComplexGrammar)) {
          var expression = StringBuilder_init_$Create$();
          var currentOffset = shouldGroup ? offset + 1 | 0 : offset;
          // Inline function 'kotlin.collections.forEachIndexed' call
          var index = 0;
          var _iterator__ex2g4s = _this__u8e3s4.x3f().l();
          while (_iterator__ex2g4s.m()) {
            var item = _iterator__ex2g4s.n();
            var _unary__edvuaz = index;
            index = _unary__edvuaz + 1 | 0;
            var index_0 = checkIndexOverflow(_unary__edvuaz);
            var current = toRegex(item, groups, currentOffset, true);
            var tmp_0;
            if (!(index_0 === 0)) {
              tmp_0 = _this__u8e3s4 instanceof OrGrammar;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              expression.k7('|');
            }
            expression.k7(current.i3g_1);
            currentOffset = currentOffset + current.j3g_1 | 0;
          }
          var groupsCount = shouldGroup ? (currentOffset - offset | 0) - 1 | 0 : currentOffset - offset | 0;
          tmp = new GrammarRegex(expression.toString(), groupsCount, shouldGroup);
        } else {
          if (isInterface(_this__u8e3s4, SimpleGrammar)) {
            var tmp_1;
            if (_this__u8e3s4 instanceof MaybeGrammar) {
              tmp_1 = _Char___init__impl__6a9atx(63);
            } else {
              if (_this__u8e3s4 instanceof ManyGrammar) {
                tmp_1 = _Char___init__impl__6a9atx(42);
              } else {
                if (_this__u8e3s4 instanceof AtLeastOne) {
                  tmp_1 = _Char___init__impl__6a9atx(43);
                } else {
                  var message = 'Unsupported simple grammar element: ' + toString(_this__u8e3s4);
                  throw IllegalStateException_init_$Create$(toString(message));
                }
              }
            }
            var operator = tmp_1;
            var nested_0 = toRegex(_this__u8e3s4.b3g(), groups, offset, true);
            tmp = new GrammarRegex(nested_0.i3g_1 + toString_0(operator), nested_0.j3g_1);
          } else {
            if (_this__u8e3s4 instanceof AnyOfGrammar) {
              tmp = new GrammarRegex('[' + Companion_getInstance().jc(_this__u8e3s4.k3g_1) + ']');
            } else {
              if (_this__u8e3s4 instanceof RangeGrammar) {
                tmp = new GrammarRegex('[' + toString_0(_this__u8e3s4.e3g_1) + '-' + toString_0(_this__u8e3s4.f3g_1) + ']');
              } else {
                var message_0 = 'Unsupported grammar element: ' + toString(_this__u8e3s4);
                throw IllegalStateException_init_$Create$(toString(message_0));
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function add(_this__u8e3s4, key, value) {
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  if (!(isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).f2(key)) {
    // Inline function 'kotlin.collections.mutableListOf' call
    // Inline function 'kotlin.collections.set' call
    var value_0 = ArrayList_init_$Create$_0();
    _this__u8e3s4.a2(key, value_0);
  }
  // Inline function 'kotlin.collections.plusAssign' call
  ensureNotNull(_this__u8e3s4.h2(key)).j(value);
}
function get_origin(_this__u8e3s4) {
  return PlatformUtils_getInstance().p2w_1 ? locationOrigin() : 'http://localhost';
}
function locationOrigin() {
  return function () {
    var tmpLocation = null;
    if (typeof window !== 'undefined') {
      tmpLocation = window.location;
    } else if (typeof self !== 'undefined') {
      tmpLocation = self.location;
    }
    var origin = '';
    if (tmpLocation) {
      origin = tmpLocation.origin;
    }
    return origin && origin != 'null' ? origin : 'http://localhost';
  }();
}
//region block: post-declaration
protoOf($serializer).a11 = typeParametersSerializers;
protoOf(EmptyHeaders).g1c = get;
protoOf(EmptyHeaders).k2x = forEach;
protoOf(EmptyParameters).g1c = get;
protoOf(EmptyParameters).k2x = forEach;
//endregion
//region block: init
Companion_instance_1 = new Companion_1();
EmptyHeaders_instance = new EmptyHeaders();
EmptyParameters_instance = new EmptyParameters();
Companion_instance_9 = new Companion_9();
NullBody_instance = new NullBody();
//endregion
//region block: exports
export {
  CookieEncoding_RAW_getInstance as CookieEncoding_RAW_getInstancelgliu5pjdx3k,
  NullBody_instance as NullBody_instance2i6w0hfghwfg0,
  Application_getInstance as Application_getInstanceq87g3bor693u,
  Companion_getInstance_0 as Companion_getInstancecf9b3ybko8sp,
  MultiPart_getInstance as MultiPart_getInstance1zzge3g94afj6,
  Text_getInstance as Text_getInstance1qa6l8g2r3h9g,
  Companion_getInstance_3 as Companion_getInstance2krh5pmq7pw0k,
  HttpHeaders_getInstance as HttpHeaders_getInstanceelogg8fjd54u,
  Companion_getInstance_4 as Companion_getInstance1p3cpld7r1jz3,
  Companion_getInstance_5 as Companion_getInstance312jiahuid5ey,
  Companion_getInstance_6 as Companion_getInstanceud97dyzf471m,
  ByteArrayContent as ByteArrayContent9zol65b22hp0,
  MultiPartData as MultiPartData57syw40llxls,
  NullBody as NullBody1903zz7riiwr0,
  ByteArrayContent_0 as ByteArrayContent2n0wb43y6ugs1,
  ContentWrapper as ContentWrapper3n9gdymgnbto9,
  NoContent as NoContent1bdx48poqrifq,
  ProtocolUpgrade as ProtocolUpgradexnnpt2xliy8g,
  ReadChannelContent as ReadChannelContentz1amb4hnpqp4,
  WriteChannelContent as WriteChannelContent1d7f40hsfcaxg,
  OutgoingContent as OutgoingContent3t2ohmyam9o76,
  TextContent as TextContent1rb6ftlpvl1d2,
  isEmpty as isEmpty1yq29t926r0va,
  ContentType as ContentType1svlpabm9v7iz,
  Cookie as Cookie2mi3e4peeulg2,
  HeadersBuilder as HeadersBuilder3h7sn3kkvu98m,
  HttpStatusCode as HttpStatusCode3o1wkms10pg4k,
  ParametersBuilder as ParametersBuilder1ry9ntvvg567r,
  URLBuilder_1 as URLBuilder1hwx1b9569i61,
  URLBuilder as URLBuilder2mz8zkz4u9ray,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
  get_authority as get_authorityakhc3pgcrb9j,
  get_authority_0 as get_authority2s3hk87lssumy,
  charset_0 as charset3qqtyytkmxogi,
  charset as charset1dribv3ku48b1,
  clone as clone36ocpwr7g14r5,
  contentLength as contentLength2suzxu1lzutku,
  contentType as contentType2zzm38yxo3syt,
  contentType_1 as contentType1lwcfjsjo0z8g,
  contentType_0 as contentType317fn4f991q9a,
  encodeURLParameter as encodeURLParameter1u3y18ab0iker,
  get_encodedPath as get_encodedPathb4r5okm1fzvh,
  get_fullPath as get_fullPath1nnuhxveoo485,
  headersOf as headersOf2tgdoojg8tifn,
  hostIsIp as hostIsIp3bb88hkcut0h0,
  isSecure as isSecurex1qiiavqi0xu,
  isWebsocket as isWebsocket1w1xog9vfgwm1,
  parseAndSortHeader as parseAndSortHeader33xgq5fx7y6j1,
  parseClientCookiesHeader as parseClientCookiesHeadert8p20xfeewy,
  parseQueryString as parseQueryString1nwcni3n22i7m,
  renderCookieHeader as renderCookieHeader384jfdw23qi6g,
  setCookie as setCookie224ax7zijawy2,
  get_supportsRequestBody as get_supportsRequestBodyjdtitrt33hir,
  takeFrom_0 as takeFromkqlcz7c6dx2r,
  takeFrom as takeFrom3rd40szpqy350,
  withCharsetIfNeeded as withCharsetIfNeeded3sz33ys0x9vfx,
  withCharset as withCharset27k3t3dvzhi4n,
};
//endregion

//# sourceMappingURL=ktor-ktor-http.mjs.map
